import { Post, IPost, Convo } from "../AVCore/AVCore";
import React, { FC, useState, useRef, useEffect } from "react";
import { Person } from "../AVCore/Person";
import * as AV from "../AVCore/Interfaces/AV.Interfaces";
import {
  setIsConvoScreenOpen,
  setLastFeedUpdate,
  setisActive,
  setConvoOpen,
  setPostPopupExpanded,
} from "../Redux/Actions/userActions";
import { AVEntity } from "../AVCore/AVEntity";
import { setConvo } from "../Redux/Actions/convoActions";
import { useDispatch, useSelector } from "react-redux";
import { Server } from "../Platform/Server";
import { Alert } from "../AVCore/Alert";
import { setAlerts } from "../Redux/Actions/alertActions";
import _ from "lodash";
import { store } from "../Redux/store";
import axios from "axios";
import { Loc } from "../App/Loc";
import { AVBase } from "../AVCore/AVBase";
import { SignalRService } from "../AVCore/SignalR";
import CustomToast from "../Hooks/useCustomToast";
import useDrivePicker from "react-google-drive-picker";
import { RootState } from "../types_interface/RootState";
import { IConversation } from "../AVCore/Interfaces/Conversation";
import { IMedia } from "../AVCore/Interfaces/Media";
import { ILink } from "../AVCore/Interfaces/Ref";
import { Media } from "../AVCore/Media";
import { ILinkParam } from "../AVCore/Interfaces/Params";
import { Feed } from "../AVCore/Feed";
import { Profanity, CensorType } from "../Profanity";
import type { ScrollView as ScrollViewType } from "react-native";
import Webcam from "react-webcam";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import type SunEditorCore from "suneditor/src/lib/core";

interface ImageFile extends File {
  type: string;
  name: string;
}
interface OneDriveData {
  name: string;
  type: string;
  size: number;
  blob: Blob;
}

interface ConvoPost extends AV.IPost {
  ReplyPost?: ConvoPost[];
  isTranslateText?: boolean;
  galleryPost?: AV.IMedia[];
}

const useConvoChat = () => {
  let textSearchRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const isConvoScreenOpen = useSelector(
    (state: RootState) => state.user.isConvoScreenOpen,
  );
  const useralertList = useSelector(
    (state: RootState) => state?.alerts.alert,
  ) as AV.IAlert[];

  const [mdlCreateConvoVisible, setMdlCreateConvoVisible] = useState(false);
  const [showFeedbackImpressions, setShowFeedbackImpressions] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [filteredResults, setFilteredResults] = useState<AV.ILink[]>();
  const [showSearch, setShowSearch] = useState(false);
  const [showFilePicker, setShowFilePicker] = useState(false);
  const [mdlConvoVisible, setMdlConvoVisible] = useState(false);
  const [convoSubject, setConvoSubject] = useState("");
  const [convoPost, setConvoPost] = useState<IPost[]>([]);
  const [convo, setConvos] = useState<any>();
  const [showConvoFilePicker, setShowConvoFilePicker] = useState(false);
  const [media, setMedia] = useState<any>([]);
  const [gallery, setGallery] = useState<IMedia[]>([]);
  const [chatMessage, setChatMessage] = useState("");
  const [value, setValue] = useState<string>("");
  const [shrink, setShrink] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [videoUrls, setvideos] = useState<any>([]);
  const [Imagesurl, setImagesurl] = useState<IMedia[]>([]);
  const [isCommentLoading, setIsCommentLoading] = useState(false);
  const [isLoading, setConvoLoading] = useState(false);
  const [Loading, setLoading] = useState(false);
  let userconvo = useSelector((state: any) => state.convo.convo[0]);
  const currentUser = useSelector((state: any) => state?.user?.user[0]);
  const lastUpdateFeed = useSelector((state: any) => state.user.lastUpdateFeed);
  const [showAddMedia, setShowAddMedia] = useState(false);
  const [picker, setPicker] = useState(false);
  const [isImageProcessing, setIsImageProcessing] = useState<boolean>(false);
  const [noticeMessage, setNoticeMessage] = useState<string>("");
  const [images, setImages] = useState<any[]>([]);
  const [deletedImages, setDeletedImages] = useState<string[]>([]);
  const [toFK, settoFK] = useState<any>();
  const [isDelete, setIsdelete] = useState<boolean>(false);
  const [videos, setvideoss] = useState([]);
  const usernewalert = useSelector(
    (state: RootState) => state?.alerts?.newalert[0],
  );
  const [profile, Setprofile] = useState<any>();
  const [isHide, setIsHide] = useState(false);
  const [removePeople, setremovePeople] = useState<AV.IFK[]>([]);
  const [replyValue, setreplyValue] = useState<any>("");
  const [currentconvochat, setcurrentconvochat] = useState<IConversation>();
  const refConvoList = useRef<any>(null);
  const [itemEdit, setItemEdit] = useState<any>();
  const [translateItem, setTranslateItem] = useState<ConvoPost>();
  const [editingImage, setEditingImage] = useState(false);
  const [isSetText, setIsSetText] = useState(false);
  const userisactive = useSelector((state: RootState) => state?.user?.active);
  const convoval = useSelector((state: RootState) => state.convo.convo[0]);
  const [fetchloading, setFetchLoading] = useState(false);
  const [pendingMessages, setPendingMessages] = useState<any>([]);
  const [alertMessage, setAlertMessage] = useState("");
  const imageInputRef = useRef<HTMLDivElement>(null);
  const [updateConvoImage, setUpdateConvoImage] = useState<IMedia[]>([]);
  const [updateConvoVideo, setUpdateConvoVideo] = useState<IMedia[]>([]);
  const [typingUserName, setTypingUserName] = useState("");
  const [isConvo, setIsConvo] = useState<boolean>(false);
  const [openPicker, authResponse] = useDrivePicker();
  const [externalLink, setExternalLink] = useState("");
  const [isOpenBox, setIsOpenBox] = useState(false);
  const [addLinkLoad, setAddLinkLoad] = useState(false);
  const [showExternalLinkInput, setShowExternalLinkInput] = useState(false);
  const [isOpenCemera, setIsOpenCemera] = useState<boolean>(false);
  const camera = useRef<any>(null);
  const [TriggerOpenConvo, setIsTriggerOpenConvo] = useState<boolean>(false);
  const [isYoutube, setIsYouTube] = useState<boolean>(false);
  const [isOnedriveData, setIsOneDriveData] = useState<any>(null);
  const [galleryPost, setGalleryPost] = useState<AV.IPost[]>([]);
  const [galleryArray, setGalleryArray] = useState<string[]>([]);
  const [showInsufficientCredits, setShowInsufficientCredits] = useState(false);
  const profanity = new Profanity({
    languages: ["en", "de", "fr", "es"],
  });

  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);

  // Add a ref to track the current chat ID
  const currentConvoIdRef = useRef<string | null>(null);

  // Chat scroll
  const scrollRef = useRef<ScrollViewType>(null);
  const prevScrollHeightRef = useRef<number | null>(null);
  const prevScrollTopRef = useRef<number | null>(null);
  const loadingOldMessagesRef = useRef<boolean>(false);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const [isMessageSent, setIsMessageSent] = useState<boolean>(false);

  // RichTextEditor(Formatting Post)
  const [isExpanded, setIsExpanded] = useState(false);
  const editorRef = useRef<SunEditorCore | null>(null);
  const [useRichText, setUseRichText] = useState(false);
  const [rteValue, setRteValue] = useState("");
  const customFonts = [
    "Arial",
    "Calibri",
    "Cambria",
    "Candara",
    "Comic Sans MS",
    "Consolas",
    "Constantia",
    "Corbel",
    "Courier New",
    "Georgia",
    "Impact",
    "Lucida Console",
    "Lucida Sans Unicode",
    "Palatino Linotype",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Tahoma",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
  ];
  const toolbarOptions = {
    buttonList: [
      ["font", "fontSize"],
      ["fontColor", "hiliteColor"],
      ["bold", "italic", "underline", "strike"],
      ["align", "list"],
      ["link", "image"],
      ["undo", "redo"],
    ],
    showPathLabel: false,
    //resizingBar: false,
    defaultStyle: "font-family: Arial; font-size: 16px;",
    placeholder:
      Loc?.currentLang?.menu?.typeYourMsgHere || "Type your message here...",
    font: customFonts,
    fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 64, 128],
  };

  const [bgColor, setBgColor] = useState<string>("");
  const [bgImage, setBgImage] = useState<string>("");
  const [bgImgWidth, setBgImgWidth] = useState<string>("");
  const [bgImgHeight, setBgImgHeight] = useState<string>("");

  // camera
  const [cameraMode, setCameraMode] = useState<"photo" | "video">("photo");
  const [recording, setRecording] = useState(false);
  const [duration, setDuration] = useState(0);
  const recordedChunksRef = useRef<Blob[]>([]);
  const webcamRef = useRef<Webcam | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const durationRef = useRef<number | null>(null);
  const isCancelledRef = useRef(false);

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const formatDuration = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (recording) {
      durationRef.current = window.setInterval(() => {
        setDuration((prev) => prev + 1);
      }, 1000);
    } else {
      if (durationRef.current !== null) clearInterval(durationRef.current);
      setDuration(0);
    }

    return () => {
      if (durationRef.current !== null) clearInterval(durationRef.current);
    };
  }, [recording]);

  // Handles image file uploads from input element
  const handleImages = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setAlertMessage("");
    setLoading(true);
    let files: any = Array.from(e?.target?.files || []);

    const updatedFiles = files.map((file: ImageFile) => {
      const fileName = file.name;
      if (fileName.toLowerCase().endsWith(".jfif")) {
        const updatedFileName = fileName.replace(/\.\w+$/, ".jpg");
        const updatedFile = new File([file], updatedFileName, {
          type: "image/jpeg",
        }) as ImageFile;
        return updatedFile;
      } else {
        return file;
      }
    });
    files = updatedFiles;

    let m = "";
    if (files.length > 20) {
      m = Loc.currentLang?.alertMessages?.maxUploadFiles;
      let clientError = { message: m };
      CustomToast({ clientError });
      return;
    }

    setShowAddMedia(false);
    setPicker(false);
    files.forEach((img: ImageFile) => {
      if (
        img.type !== "image/jpeg" &&
        img.type !== "image/jfif" &&
        img.type !== "image/png" &&
        /*img.type !== "image/webp" &&*/
        img.type !== "image/gif" &&
        img.type !== "video/mp4" &&
        img.type !== "video/quicktime"
      ) {
        m =
          Loc.currentLang.alertMessages.supportedFormats ||
          "format is unsupported ! only Jpeg,Jfif, Png, Webp, Gif are allowed.";
        files = files.filter((item: ImageFile) => item.name !== img.name);
        let clientError = { message: m };
        CustomToast({ clientError });
        return;
      }
    });

    console.log(files);
    setIsImageProcessing(true);
    setNoticeMessage("Please wait while we process your images...");

    let data: AV.IMedia[] = [];
    if (files?.length > 0) {
      data = await Media.saveFiles(
        Media.getFormData(files),
        currentUser?.region || undefined,
      );

      if (data[0]?.status == "Invalid Size") {
        CustomToast(Loc.currentLang.alertMessages.largeVideo);
        setNoticeMessage("");
        setLoading(false);
        setIsImageProcessing(false);
        setLoading(false);

        return;
      }

      //setMedia((prev: AV.IMedia[]) => [...prev, data]);
      //setImages((prev: AV.IMedia[]) => [...prev, data]);

      data?.forEach((img: AV.IMedia) => {
        setMedia((prev: AV.IMedia[]) => [...prev, img]);
        setImages((prev: AV.IMedia[]) => [...prev, img]);

        if (img.type.startsWith("image")) {
          setImagesurl((imagesurl: AV.IMedia[]) => [...imagesurl, img]);
          setUpdateConvoImage((imagesurl: AV.IMedia[]) => [...imagesurl, img]);
        } else {
          setvideos((videos: AV.IMedia[]) => [...videos, img]);
          setUpdateConvoVideo((videos: AV.IMedia[]) => [...videos, img]);
        }
      });

      setShowConvoFilePicker(true);
    } else {
      setShowConvoFilePicker(false);
    }

    if (media?.length > 0 || data?.length > 0) {
      setShowConvoFilePicker(true);
    } else {
      setShowConvoFilePicker(false);
    }

    setNoticeMessage("");
    setLoading(false);
    setIsImageProcessing(false);
    setLoading(false);
  };

  // Handles voice file uploads
  const handleVoice = async (item: File[]) => {
    setAlertMessage("");
    const fileInput = imageInputRef.current as HTMLInputElement;
    setLoading(true);
    let files: File[] = item;
    let m = "";
    console.log(files);
    if (files.length > 20) {
      m = Loc.currentLang.alertMessages.maxFiles;
      setAlertMessage(m);
      setLoading(false);
      setIsImageProcessing(false);
      return;
    }

    setShowAddMedia(false);
    setPicker(false);

    // Convert File[] to FileList for Media.getFormData
    const fileList = new DataTransfer();
    files.forEach((file) => fileList.items.add(file));
    const formData = Media.getFormData(fileList.files);

    const data = await Media.saveFiles(
      formData,
      currentUser?.region || undefined,
    );
    setMedia((prev: AV.IMedia[]) => [...prev, ...data]);
    setImages((prev: AV.IMedia[]) => [...prev, ...data]);
    setNoticeMessage("");
    setLoading(false);
    setIsImageProcessing(false);
    //setShowConvoFilePicker( true );
    if (fileInput) {
      fileInput.value = "";
    }
  };

  // Handles adding document links to conversation
  const HandleAddDocsLink = async (link) => {
    setIsOpenBox(false);
    setLoading(true);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    for (let i = 0; i < link?.length; i++) {
      const isValidLink =
        /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;
      if (!isValidLink?.test(link[i]?.embedUrl)) {
        let clientError = { message: Loc.currentLang.menu.invalidUrl };
        CustomToast({ clientError }); // Display error message using CustomToast
        setAddLinkLoad(false);
        setExternalLink("");
        setShowExternalLinkInput(false);
        return; // Exit the function early if the link format is invalid
      }
      let fd = new FormData();
      fd.append("linkURL", link[i]?.embedUrl);
      if (
        link[i]?.mimeType !== "image/jpeg" &&
        link[i]?.mimeType !== "image/jfif" &&
        link[i]?.mimeType !== "image/png" &&
        /*link[i]?.mimeType !== "image/webp" &&*/
        link[i]?.mimeType !== "image/gif" &&
        link[i]?.mimeType !== "video/mp4" &&
        link[i]?.mimeType !== "video/quicktime"
      ) {
        let m =
          Loc.currentLang.postPopup
            .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
        setIsOpenBox(false);
        setLoading(false);
        setAddLinkLoad(false);
        setIsImageProcessing(false);
        setAlertMessage(m);
        return;
      }
      const data = await Media.saveFiles(fd, currentUser?.region);
      data[0].linkURL = link[i]?.embedUrl;
      data[0].orgFile = link[i]?.mimeType.startsWith("image")
        ? "GoogleDrive.jpg"
        : "GoogleDrive.mp4";
      data[0].type = "iframe";
      //setMedia((prev: AV.IMedia[]) => [...prev, data]);

      data?.forEach((img) => {
        setMedia((prev: AV.IMedia[]) => [...prev, img]);
        setImages((prev: AV.IMedia[]) => [...prev, img]);
        setImagesurl((imagesurl: AV.IMedia[]) => [...imagesurl, img]);

        if (img.type.startsWith("image")) {
          setImagesurl((imagesurl) => [...imagesurl, img]);
          setImagesurl((imagesurl: AV.IMedia[]) => [...imagesurl, img]);
          setUpdateConvoImage((imagesurl: AV.IMedia[]) => [...imagesurl, img]);
        } else {
          setvideos((videos: AV.IMedia[]) => [...videos, img]);
          setUpdateConvoVideo((videos: AV.IMedia[]) => [...videos, img]);
        }
      });
    }
    setAddLinkLoad(false);
    setLoading(false);
    setShowExternalLinkInput(false);
    setShowConvoFilePicker(true);
    setIsImageProcessing(false);
  };

  // Converts base64 string to File object
  function base64ToFile2(base64: string, filename: string): File {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // Utility to convert File[] to FileList
  function createFileList(files: File[]): FileList {
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    return dataTransfer.files;
  }

  const handleCameraPhotoCapture = async () => {
    setAlertMessage("");
    setLoading(true);
    setIsOpenCemera(false);

    if (!webcamRef.current) {
      console.error("Webcam not available");
      return;
    }

    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      console.error("Failed to capture image from webcam");
      return;
    }

    let file = base64ToFile2(imageSrc, "captured-image.jpg");

    // Limit file count
    const files: File[] = [file];
    if (files.length > 20) {
      const m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang?.postPopup?.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    // UI State
    setShowAddMedia(false);
    setPicker(false);
    setIsImageProcessing(true);

    // Preview file
    const reader = new FileReader();
    //reader.onload = (e) => {
    //  setImages((prev) => [...prev, e.target?.result]);
    //};
    reader.readAsDataURL(file);

    try {
      const fileList = createFileList(files);
      const data = await Media.saveFiles(
        Media.getFormData(fileList),
        currentUser?.region,
      );

      if (data?.length > 0) {
        //setMedia((prev: AV.IMedia[]) => [...prev, data]);
        //setImages((prev: AV.IMedia[]) => [...prev, data]);

        data.forEach((img: IMedia) => {
          setMedia((prev: AV.IMedia[]) => [...prev, img]);
          setImages((prev: AV.IMedia[]) => [...prev, img]);
          setImagesurl((imagesurl) => [...imagesurl, img]);
          //setImages((images) => [...images, img.linkURL]);
          setUpdateConvoImage((imagesurl) => [...imagesurl, img]);
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setAlertMessage("Upload failed. Please try again.");
    } finally {
      setLoading(false);
      setIsImageProcessing(false);
      setShowConvoFilePicker(true);
      onClose();
    }
  };

  const handleCameraVideoCapture = async (chunks: Blob[]) => {
    setAlertMessage("");
    setLoading(true);
    setIsOpenCemera(false);

    const blob = new Blob(chunks, { type: "video/webm" });
    const file = new File([blob], "recorded-video.webm", {
      type: "video/webm",
    });

    const files: File[] = [file];
    if (files.length > 20) {
      const m =
        Loc.currentLang?.alertMessages?.maxUploadFiles ||
        Loc.currentLang?.postPopup?.youCannotUploadMoreThan20FilesPerPost;
      setAlertMessage(m);
      return;
    }

    setShowAddMedia(false);
    setPicker(false);
    setIsImageProcessing(true);

    const reader = new FileReader();
    //reader.onload = (e) => {
    //  setvideos((prev) => [...prev, e.target?.result]);
    //};
    reader.readAsDataURL(file);

    try {
      const fileList = createFileList(files);
      const data = await Media.saveFiles(
        Media.getFormData(fileList),
        currentUser?.region,
      );

      if (data?.length > 0) {
        //setMedia((prev: AV.IMedia[]) => [...prev, data]);
        //setImages((prev: AV.IMedia[]) => [...prev, data]);

        data.forEach((img: IMedia) => {
          setMedia((prev: AV.IMedia[]) => [...prev, img]);
          setImages((prev: AV.IMedia[]) => [...prev, img]);
          setvideos((videos: AV.IMedia[]) => [...videos, img]);
          setUpdateConvoVideo((videos: AV.IMedia[]) => [...videos, img]);
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setAlertMessage("Upload failed. Please try again.");
    } finally {
      if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();
        setRecording(false);
      }
      setLoading(false);
      setIsImageProcessing(false);
      setShowConvoFilePicker(true);
      onClose();
    }
  };

  const handleStartRecording = () => {
    setAlertMessage("");
    recordedChunksRef.current = [];

    const stream = webcamRef.current?.stream;

    if (!stream) {
      console.error("Webcam stream not available");
      return;
    }

    const mediaRecorder = new MediaRecorder(stream, {
      mimeType: "video/webm; codecs=vp9",
    });

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        recordedChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      if (!isCancelledRef.current) {
        handleCameraVideoCapture(recordedChunksRef.current);
      } else {
        isCancelledRef.current = false; // reset flag for future recordings
      }
    };

    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.start();
    setRecording(true);
  };

  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  const toggleMode = () => {
    if (recording) {
      isCancelledRef.current = true; // mark that we're switching mode and canceling recording
      handleStopRecording();
    }

    setCameraMode((prev) => (prev === "photo" ? "video" : "photo"));
  };

  const onClose = () => {
    setIsOpenCemera(false);
    setRecording(false);
    setDuration(0);
    setCameraMode("photo");
    if (durationRef.current !== null) clearInterval(durationRef.current);
  };

  // Makes API calls with Link Preview
  const apiCall = async (url) => {
    try {
      const response = await axios.get("https://api.linkpreview.net", {
        params: {
          key: "fa7a7a675495a6cc97dac00c791ddb6b",
          q: url,
        },
      });
      // Check if response data exists
      if (response.data) {
        return response.data;
      } else {
        throw new Error("No data returned from API");
      }
    } catch (error) {
      setAddLinkLoad(false);
      setLoading(false);
      setIsImageProcessing(false);
      setExternalLink("");
      setShowExternalLinkInput(false);
      let clientError = { message: Loc.currentLang.menu.invalidUrl };
      CustomToast({ clientError }); // Display error message using CustomToast
      console.error("Error fetching URL preview:", error);
      // Handle error appropriately (you could return a default value, throw error, etc.)
      throw new Error("Failed to fetch data from the API");
    }
  };

  // Converts share links to embed format
  function convertToEmbedLink(shareLink) {
    const url = new URL(shareLink);

    // Extract the video ID from the share link
    const videoId = url.pathname.split("/")[1];

    // Extract query parameters
    const queryParams = url.search;

    // Construct the embed link
    return `https://www.youtube.com/embed/${videoId}${queryParams}`;
  }

  // Handles adding external URLs to conversation
  const HandleAddExternalUrl = async () => {
    setAlertMessage("");
    setLoading(true);
    setIsOpenBox(false);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    //let newLink = externalLink;
    let getExternalLinkType = isYoutube ? "iframe" : "linkPreview";
    let linkOfYoutube = "";
    const isValidLink =
      /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;
    if (!isValidLink?.test(externalLink)) {
      let clientError = { message: Loc.currentLang.menu.invalidUrl };
      CustomToast({ clientError }); // Display error message using CustomToast
      setAddLinkLoad(false);
      setLoading(false);
      setIsImageProcessing(false);
      setExternalLink("");
      setShowExternalLinkInput(false);
      return; // Exit the function early if the link format is invalid
    }
    let fd = new FormData();
    fd.append("linkURL", externalLink);
    const data = await Media.saveFiles(fd, currentUser?.region);
    let response = await apiCall(externalLink);
    if (isYoutube) {
      linkOfYoutube = await convertToEmbedLink(externalLink);
    }
    data[0].linkURL = isYoutube ? linkOfYoutube : externalLink;
    data[0].orgFile =
      response?.image?.trim()?.length > 0
        ? response?.image
        : "https://cdn.pixabay.com/photo/2022/01/11/21/48/link-6931554_1280.png";
    data[0].type = getExternalLinkType;
    //setMedia((prev: AV.IMedia[]) => [...prev, data]);

    if (data?.length > 0) {
      data?.forEach((img) => {
        setMedia((prev: AV.IMedia[]) => [...prev, img]);
        setImages((prev: AV.IMedia[]) => [...prev, img]);
        setImagesurl((imagesurl) => [...imagesurl, img]);
        if (img.type.startsWith("image")) {
          setImagesurl((imagesurl) => [...imagesurl, img]);
          setImages((images) => [...images, img.linkURL]);
          setUpdateConvoImage((imagesurl) => [...imagesurl, img]);
        } else {
          setvideos((videos) => [...videos, img]);
          setUpdateConvoVideo((videos) => [...videos, img]);
        }
      });
    }
    setAddLinkLoad(false);
    setLoading(false);
    setExternalLink("");
    setShowExternalLinkInput(false);
    setShowConvoFilePicker(true);
    setIsImageProcessing(false);
  };

  // Handles external link input changes
  const handleExternalLink = (e) => {
    setExternalLink(e.target.value);
  };

  // Handles OneDrive integration
  const HandleAddOneDrive = async () => {
    setAlertMessage("");
    setIsOpenBox(false);
    setLoading(true);
    setAddLinkLoad(true);
    setIsImageProcessing(true);

    console.log("isOnedriveData data:", isOnedriveData);
    const mimeType: any = isOnedriveData?.type;
    const validTypes = [
      "image/jpeg",
      "image/jfif",
      "image/png",
      /* "image/webp",*/
      "image/gif",
      "video/mp4",
      "video/quicktime",
    ];

    if (!validTypes.includes(mimeType)) {
      let m =
        Loc.currentLang.postPopup
          .formatIsUnsupportedOnlyJpegJfifPngWebpGifAreAllowed;
      setAddLinkLoad(false);
      setIsImageProcessing(false);
      setShowExternalLinkInput(false);
      setAlertMessage(m);
      return;
    }

    // Append the file blob
    const fd = new FormData();
    fd.append("file", isOnedriveData?.blob, isOnedriveData?.name);

    try {
      console.log("Form data: ", fd);
      const data = await Media.saveFiles(fd, currentUser?.region);
      console.log("API response: ", data);

      if (data?.length > 0) {
        setMedia((prev) => [...prev, ...data]);
        data?.forEach((img) => {
          setImages((prev: AV.IMedia[]) => [...prev, img]);
          setImagesurl((imagesurl) => [...imagesurl, img]);
          if (img.type.startsWith("image")) {
            setImagesurl((imagesurl) => [...imagesurl, img]);
            setUpdateConvoImage((imagesurl) => [...imagesurl, img]);
          } else {
            setvideos((videos) => [...videos, img]);
            setUpdateConvoVideo((videos: AV.IMedia[]) => [...videos, img]);
          }
        });
      }
    } catch (err) {
      console.error("Error uploading to API", err);
      CustomToast({ clientError: { message: "Upload failed" } });
    }

    setAddLinkLoad(false);
    setLoading(false);
    setShowExternalLinkInput(false);
    setShowConvoFilePicker(true);
    setIsImageProcessing(false);
  };

  // Opens file picker dialog
  const handleOpenPicker = () => {
    openPicker({
      clientId:
        "143407568263-uh85ecaqapgumtq787b2m3mu0l1sm0ve.apps.googleusercontent.com",
      developerKey: "AIzaSyCgz1ryXdQ2aDugOM1-dNHuz1Pavi1n230",
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.action === "cancel") {
          console.log("User clicked cancel/close button");
        }
        if (data?.action !== "loaded") {
          HandleAddDocsLink(data?.docs);
        }
      },
    });
  };

  // Handles Dropbox link integration
  const HandleAddDropBoxLink = async (link) => {
    setIsOpenBox(false);
    setLoading(true);
    setAddLinkLoad(true);
    setIsImageProcessing(true);
    for (let i = 0; i < link?.length; i++) {
      const isValidLink =
        /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;
      if (!isValidLink?.test(link[i]?.thumbnailLink)) {
        let clientError = { message: Loc.currentLang.menu.invalidUrl };
        CustomToast({ clientError }); // Display error message using CustomToast
        setAddLinkLoad(false);
        setExternalLink("");
        setShowExternalLinkInput(false);
        return; // Exit the function early if the link format is invalid
      }
      let fd = new FormData();
      fd.append("linkURL", link[i]?.thumbnailLink);
      const data = await Media.saveFiles(fd, currentUser?.region);
      data[0].linkURL = link[i]?.link;
      data[0].orgFile = link[i]?.thumbnailLink;
      data[0].type = "dropbox";
      //setMedia((prev: AV.IMedia[]) => [...prev, data]);

      if (data?.length > 0) {
        data?.forEach((img: any) => {
          setMedia((prev: AV.IMedia[]) => [...prev, img]);
          setImages((prev: AV.IMedia[]) => [...prev, img]);

          if (img.type.startsWith("image")) {
            setImagesurl((imagesurl: AV.IMedia[]) => [...imagesurl, img]);
            setUpdateConvoImage((imagesurl: AV.IMedia[]) => [
              ...imagesurl,
              img,
            ]);
            setUpdateConvoImage((imagesurl) => [...imagesurl, img]);
          } else {
            setvideos((videos: AV.IMedia[]) => [...videos, img]);
            setUpdateConvoVideo((videos: AV.IMedia[]) => [...videos, img]);
          }
        });
      }
    }

    setAddLinkLoad(false);
    setLoading(false);
    setShowConvoFilePicker(true);
    setShowExternalLinkInput(false);
    setIsImageProcessing(false);
  };

  // Creates a new conversation model
  const handleCreateModel = async () => {
    setValue("");
    settoFK([]);
    setSearchInput("");
    setSubject("");
    setIsHide(false);
    setMdlCreateConvoVisible(!mdlCreateConvoVisible);
    setShowConvoFilePicker(false);
    setMdlConvoVisible(false);
  };

  // Searches for items in conversation
  const searchItems = async (searchValue: string) => {
    setSearchInput(searchValue);

    if (searchValue !== "") {
      let searchData = [
        ...(currentUser?.follows ?? []),
        ...(currentUser?.members ?? []),
      ];
      searchData = _.uniqBy(searchData, "id");

      for (var i = 0; i < toFK?.length; i++) {
        searchData = searchData.filter((x) => x?.id !== toFK[i]?.id);
      }
      setFilteredResults(
        searchValue?.trim()?.length > 0
          ? searchData?.filter(
              (x) =>
                x.type === "Person" &&
                x?.id !== currentUser?.id &&
                x?.title
                  ?.toLocaleLowerCase()
                  .includes(searchValue.toLocaleLowerCase()),
            )
          : searchData,
      );
      setShowSearch(true);
    } else {
      setFilteredResults([]);
      setShowSearch(false);
    }
  };

  // Handles emoji selection
  const onEmojiClick = (emoji: string) => {
    const newVal = value === undefined ? emoji : value + emoji;
    setValue(newVal);
    setMessage(message + newVal);
    setShowEmoji(false);
    setValue("");
  };

  // Handles sending message to user profile
  const handleSentToProfile = (item) => {
    setShowSearch(false);
    setSearchInput("");
    settoFK((prev) => [...(prev || []), item]);
  };

  // Handles subject input changes
  const handleSubject = (e) => {
    e.preventDefault();
    setSubject(e.target.value.trim());
  };

  // Handles message input changes
  const handleMessage = (e) => {
    setValue(e.target.value);
    setMessage(e.target.value);
    setShrink(e.target.value?.trim()?.length > 0 ? true : false);
  };

  // Removes items from conversation
  const handleRemoveItem = (item) => {
    if (!toFK) return;
    settoFK(toFK.filter((x) => x.id !== item.id));
    if (convo) {
      let remove = convo?.people?.filter((x) => x.id == item.id);
      if (remove?.length > 0)
        setremovePeople((prev) => [...(prev || []), ...(remove || [])]);
    }
  };

  // Publishes conversation
  const handlePublish = async () => {
    setConvoLoading(true);
    let people: AV.ILink[] =
      toFK?.filter(
        (item1: AV.ILink) =>
          !convo?.people?.some((item2: AV.ILink) => item2?.id === item1?.id),
      ) || [];
    let returnvalue: any;
    if (removePeople?.length > 0) {
      returnvalue = await Convo.removePeople(convo, removePeople);
    }
    if (people?.length > 0) {
      returnvalue = await Convo.addPeople(convo, people);
    }
    if (convo?.subject !== subject) {
      convo.subject = subject;
      var test: any = AVBase.getFk(convo);
      test.subject = subject;
      returnvalue = await Convo.update(test);
      setConvos(returnvalue ? [returnvalue] : []);
      setConvoSubject(test?.subject);
    }
    if (returnvalue?.people) {
      const updatedConvoList = userconvo.map((conversation) => {
        if (conversation?.id === returnvalue?.id) {
          conversation.people = returnvalue?.people;
          conversation.lastUpdated = returnvalue.lastUpdated;
          return {
            ...conversation,
          };
        }
        return conversation;
      });
      dispatch(setConvo(updatedConvoList));
    } else {
      setIsHide(false);
      setMdlConvoVisible(true);
      setConvoLoading(false);
      return;
    }
    setConvos(returnvalue);
    setremovePeople([]);
    setConvoLoading(false);
    setIsHide(false);
    setMdlConvoVisible(true);
  };

  // Gets image gallery from file picker for conversation creation
  const getImageGalleryFromFilePickerCreateConvo = async (filePickerData) => {
    if (filePickerData.length > 0) {
      if (filePickerData.length > 20) {
        setMessage(Loc.currentLang?.alertMessage?.maxUploadFiles);
        return;
      }
      const data = await Media.saveFiles(
        Media.getFormData(filePickerData),
        currentUser?.region,
      );
      if (data != null) setMedia(data);
      data?.forEach((img: any) => {
        if (img.type.startsWith("image"))
          setImages((images) => [...images, img]);
        else setvideos((videos) => [...videos, img]);
      });
      setMedia([]);
      setImages([]);
    }
  };

  // Handles sending messages in conversation
  const handleSendMessage = async () => {
    setConvoLoading(true);
    let people: any = [];
    let self = Person.self();
    people = toFK;
    let convo: any = {
      subject: subject,
      ownerType: "Person",
      type: "Convo",
      people: people,
    };
    var excitingconvo = userconvo?.filter(
      (x) =>
        x?.people?.length === 2 &&
        (x?.people[0]?.id == toFK[0]?.id || x?.people[1]?.id == toFK[0]?.id),
    );
    if (!subject && excitingconvo?.length > 0) {
      convo = excitingconvo[0];
    } else {
      convo = await Convo.save(convo);
    }

    let post: any = Convo.createConvoPost(convo);
    post.owner = AVEntity.getFk(convo);
    post.text = value;
    if (media && media.length === 0) {
      post = await Post.saveConvo(post);
      if (post === Loc.currentLang.menu.inappropriateErrorMsg) {
        let clientError = {
          message: Loc.currentLang.menu.inappropriateErrorMsg,
        };
        CustomToast({ clientError });
        setConvoLoading(false);
        return;
      }
    }

    //// Attach metadata (parent + linkURL)
    //for (const mediaItem of media) {
    //  const srclink = Media.getURL(mediaItem);
    //  if (!srclink) continue;
    //  mediaItem.parent = AVEntity.getFk(convo);
    //  mediaItem.linkURL = srclink;
    //}

    if (media && media.length === 1) {
      post.media = media[0];
      post = await Post.saveConvo(post);
      if (post === Loc.currentLang.menu.inappropriateErrorMsg) {
        let clientError = {
          message: Loc.currentLang.menu.inappropriateErrorMsg,
        };
        CustomToast({ clientError });
        setConvoLoading(false);
        return;
      }
    }
    if (media && media.length > 1) {
      let galleryArray: any = [];
      let galleryPost: any = [];
      let gallery = { layout: null, Items: [] };
      post.gallery = gallery;
      const newGuid = Server.generateUUID();
      post.id = newGuid;
      let parentPostId = newGuid;
      for (var i = 0; i < media?.length; i++) {
        let post1 = Convo.createConvoPost(convo);
        post1.owner = AVEntity.getFk(convo);
        post1.parentPost = parentPostId;
        post1.media = media[i];
        post1.ptype = "G";
        let mediapost: any = await Post.saveConvo(post1);
        if (mediapost === Loc.currentLang.menu.inappropriateErrorMsg) {
          let clientError = {
            message: Loc.currentLang.menu.inappropriateErrorMsg,
          };
          CustomToast({ clientError });
          setConvoLoading(false);
          return;
        }
        dispatch(setisActive(true));
        galleryPost.push(mediapost);
        galleryArray.push(mediapost.id);
      }
      post.status = "New";
      post.gallery.items = galleryArray;
      post = await Post.saveConvo(post);
      if (post === Loc.currentLang.menu.inappropriateErrorMsg) {
        let clientError = {
          message: Loc.currentLang.menu.inappropriateErrorMsg,
        };
        CustomToast({ clientError });
        setConvoLoading(false);
        return;
      }
      dispatch(setisActive(true));
      post.galleryPost = galleryPost;
      post = post;
    }
    if (post) {
      let postdata = userconvo?.filter((x) => x?.id == post?.pk);
      if (postdata?.length > 0) {
        postdata[0].posts.push(post);
        postdata[0].lastUpdated = post.lastUpdated;
        let userconv = userconvo.filter((x) => x.id != post.pk);
        userconv.unshift(postdata[0]);
        console.log("setconvo sse4");
        dispatch(setConvo(userconv));
      } else {
        let usercon: any = [];
        if (userconvo?.length > 0) usercon = userconvo;
        convo.posts = [];
        convo.posts?.push(post);
        usercon.unshift(convo);
        dispatch(setConvo(usercon));
      }
    }
    setValue("");
    setSearchInput("");
    setImages([]);
    setGallery([]);
    setMedia([]);
    setImagesurl([]);
    setConvoLoading(false);
    handleGetConvo(convo);
    setShowConvoFilePicker(false);
    setIsTriggerOpenConvo(true);
  };

  // Handles sending single chat messages
  const handleSendSingleChat = async (toFK) => {
    setConvoLoading(true);
    let people = [];
    let self = Person.self();
    people = toFK;
    let convo: any = {
      subject: subject,
      ownerType: "Person",
      type: "Convo",
      people: people,
    };
    var excitingconvo = userconvo?.filter(
      (x) =>
        x?.people?.length === 2 &&
        (x?.people[0]?.id == toFK[0]?.id || x?.people[1]?.id == toFK[0]?.id),
    );
    if (!subject && excitingconvo?.length > 0) {
      convo = excitingconvo[0];
    } else {
      //Setprofile(people[0]);
      convo = await Convo.save(convo);

      let usercon: any = [];
      if (userconvo?.length > 0) usercon = userconvo;
      convo.posts = [];
      setConvos(convo);
      usercon.unshift(convo);
      dispatch(setConvo(usercon));
    }

    //if (excitingconvo?.length == 0) {
    //  let post = Convo.createConvoPost(convo);
    //  post = await Post.saveConvo(post);
    //  if (post === Loc.currentLang.menu.inappropriateErrorMsg) {
    //    let clientError = {
    //      message: Loc.currentLang.menu.inappropriateErrorMsg,
    //    };
    //    CustomToast({ clientError });
    //    setConvoLoading(false);
    //    return;
    //  }
    //  if (post) {
    //    let postdata = userconvo?.filter((x) => x?.id == post?.pk);
    //    if (postdata?.length > 0) {
    //      postdata[0].posts.push(post);
    //      postdata[0].lastUpdated = post.lastUpdated;
    //      let userconv = userconvo.filter((x) => x.id != post.pk);
    //      userconv.unshift(postdata[0]);
    //      dispatch(setConvo(userconv));
    //    } else {
    //      let usercon: any = [];
    //      if (userconvo?.length > 0) usercon = userconvo;
    //      convo.posts = [];
    //      // convo.posts?.push( post );
    //      setConvos(convo);
    //      usercon.unshift(convo);
    //      dispatch(setConvo(usercon));
    //    }
    //  }
    //}

    setValue("");
    setSearchInput("");
    setImages([]);
    setGallery([]);
    setMedia([]);
    setImagesurl([]);
    setConvoLoading(false);
    handleGetConvo(convo);
    setShowConvoFilePicker(false);
    return convo;
  };

  // Updates unread message count
  async function updateUnreadMessages(item) {
    let id = item?.data?.feed?.id ? item.data.feed.id : item?.id;
    const flatAlerts = useralertList.flat();

    const unReadChatMessage = flatAlerts?.filter(
      (x) =>
        x?.actionTaken == undefined &&
        x?.data?.feed?.id === id &&
        (x?.alertType === "NewDM" || x?.alertType === "ReplyDM"),
    );

    if (unReadChatMessage?.length > 0) {
      for (const message of flatAlerts) {
        if (
          message?.data?.feed?.id === id &&
          message?.actionTaken !== "Viewed" &&
          (message?.alertType === "NewDM" || message?.alertType === "ReplyDM")
        ) {
          message.actionTaken = "Viewed";
        }
      }
      dispatch(setAlerts(useralertList));
      for (let i = 0; i < unReadChatMessage.length; i++) {
        await Alert.Save(unReadChatMessage[i]);
      }
    }
  }

  // Gets conversation data
  const handleGetConvo = async (item, isOpenChat = false) => {
    // Track the current chat ID
    currentConvoIdRef.current =
      item?.id || item?.pk || item?.data?.feed?.id || null;
    // setup the signalRconnection after the chat screen opened
    //setupSignalRConnection(item?.id);
    setConvoLoading(false);
    setLoading(false);
    setIsImageProcessing(false);
    setMdlConvoVisible(true);
    setMedia([]);
    let convoPosts: any = "";
    setImages([]);
    setShowConvoFilePicker(false);
    updateUnreadMessages(item);
    //setValue("");
    setItemEdit("");
    setIsHide(false);
    setreplyValue("");

    if (item?.data?.feed?.id) {
      convoPosts = userconvo?.filter((x) => x?.id == item?.data?.feed?.id)[0];
      setcurrentconvochat(item?.data?.feed);
    } else {
      convoPosts = userconvo?.filter((x) => x?.id == item?.pk)[0];
      let postdata = item?.posts;
      postdata = postdata?.filter(
        (x) =>
          (x.ptype !== "G" && x.text !== undefined) || x.text !== undefined,
      );
      postdata = _.uniqBy(postdata, "id");
      if (postdata?.length > 0) {
        postdata = list_to_tree(postdata);
        item.posts = postdata;
      } else {
        setcurrentconvochat(item);
      }
    }

    if (!convoPosts) convoPosts = item;
    let postdata1 = convoPosts?.posts;
    if (postdata1?.length > 0) {
      postdata1 = list_to_tree(postdata1);
      convoPosts.posts = postdata1;
      setConvos(convoPosts);
    } else {
      setConvos(convoPosts);
    }
    let post = convoPosts?.posts?.sort((a, b) => {
      return (new Date(b.createDate) as any) - (new Date(a.createDate) as any);
    });
    post = list_to_tree(post);
    setConvoPost(post);
    setConvoSubject(convoPosts?.subject);
    if (
      item?.type !== "GroupConvo" &&
      item?.type !== "GameGroupConvo" &&
      item?.type !== "LeagueGameGroupConvo"
    ) {
      var userPeople = convoPosts?.people?.filter(
        (x) => convoPosts?.people?.length === 2 && x.id !== currentUser?.id,
      );
      Setprofile(userPeople[0]);
      let profilename = convoPosts?.posts?.filter(
        (x) => x?.person?.id == userPeople[0]?.id,
      );
      profilename = profilename?.sort(function (a, b) {
        let c: any = new Date(b.lastUpdated);
        let d: any = new Date(a.lastUpdated);
        return c - d;
      });
      Setprofile(
        profilename[0]?.person ? profilename[0]?.person : userPeople[0],
      );
    }

    if (isOpenChat) setMdlCreateConvoVisible(true);

    let setConvoScreenOpen = {
      isOpen: true,
      convoId: item.pk ? item.pk : item?.data?.feed?.pk,
    };
    dispatch(setIsConvoScreenOpen(setConvoScreenOpen));
    setMdlConvoVisible(true);
    setMedia([]);
  };

  // Gets group conversation data
  const handleGetGroupConvo = async (item) => {
    // Track the current chat ID
    currentConvoIdRef.current = item?.id || null;
    dispatch(setConvoOpen(true));
    //setShowConvoListModal( !showConvoListModal )
    // setup the signalRconnection after the chat screen opened
    setupSignalRConnection(item?.id);
    setConvoLoading(false);
    setLoading(false);
    setIsImageProcessing(false);
    setMdlConvoVisible(true);
    setMedia([]);
    let convoPosts: any = "";
    setImages([]);
    setShowConvoFilePicker(false);
    updateUnreadMessages(item);
    setIsHide(false);
    setreplyValue("");
    let isAlive =
      userconvo?.length > 0 && userconvo?.find((x) => x?.id == item?.id)
        ? true
        : false;
    if (!isAlive) {
      if (userconvo?.length > 0) {
        userconvo?.unshift(item);
      } else {
        userconvo = [];
        userconvo?.unshift(item);
        console.log("setConvo useconvochat 66");
        dispatch(setConvo(userconvo));
        setIsConvo(true);
      }
    }
    convoPosts = userconvo?.filter((x) => x?.id == item?.id)[0];
    setcurrentconvochat(item);
    if (!convoPosts) convoPosts = item;
    setConvos(convoPosts);
    setConvoSubject(convoPosts?.subject);

    var target = AVEntity.getFk(item);
    Setprofile(target);
    //setMdlCreateConvoVisible(true);
    let setConvoScreenOpen = {
      isOpen: true,
      convoId: item.pk ? item.pk : item?.data?.feed?.pk,
    };
    dispatch(setIsConvoScreenOpen(setConvoScreenOpen));
    setMdlConvoVisible(true);
    setMedia([]);
  };

  // Scrolls to specific message with delay
  const scrollToMessageWithDelay = (item, convoPosts) => {
    setTimeout(
      () => scrollToMessageById(item?.target?.id, convoPosts?.posts),
      200,
    );
  };

  // Scrolls to message by ID
  const scrollToMessageById = (messageId, post) => {
    if (messageId && post?.length > 0) {
      const index = post?.findIndex((item) => item.id === messageId);
      try {
        if (index !== -1 && refConvoList.current) {
          // Use type assertion here
          (refConvoList.current as any).scrollToIndex({
            index,
            animated: true,
          });
        }
      } catch (error) {
        console.error("An error occurred while scrolling:", error);
      }
    }
  };

  // Converts list data to tree structure
  const list_to_tree = (list: any) => {
    var map: any = {},
      node: any,
      roots: any = [],
      i;

    for (i = 0; i < list?.length; i += 1) {
      map[list[i]?.id] = i; // initialize the map
      if (list[i]?.children?.length === 0 || !list[i]?.children)
        list[i]["children"] = []; // initialize the children
      if (list[i]?.galleryPost?.length === 0 || !list[i]?.galleryPost)
        list[i]["galleryPost"] = [];
      list[i]["ReplyPost"] = [];
    }

    for (i = 0; i < list?.length; i += 1) {
      node = list[i];
      if (node.parentPost !== undefined) {
        if (
          list[map[node.parentPost]]?.gallery?.items?.filter(
            (x: any) => x === node.id,
          )?.length > 0 &&
          node.gallery == undefined
        ) {
          let excitingpost = list[map[node.parentPost]]?.galleryPost?.filter(
            (x: any) => x?.id === node?.id,
          );
          if (excitingpost?.length === 0 || excitingpost === undefined)
            list[map[node.parentPost]]?.galleryPost.push(node);
        } else {
          let PPost = list.filter((x: any) => x?.id === node?.parentPost);
          node.ReplyPost.push(PPost[0]);
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    }

    return roots;
  };

  // Handles text translation
  const handleTranslateText = async (item) => {
    const isAlreadyTrans = item?.trans?.some(
      (x) => x.lang === currentUser?.preferences?.lang,
    );

    const Fk = AVEntity.getFk(currentUser);
    const sharedPlan: AV.ISharedPlan = await AVEntity.getSharedPlan(Fk);
    if (sharedPlan?.plan?.credits == 0) {
      setShowInsufficientCredits(true);
      return;
    }

    // If translation already exists, just update state with the existing item
    if (isAlreadyTrans) {
      const updatedPostItem = { ...item, isTranslateText: true };

      const postData = userconvo?.find((x) => x?.id === item?.pk);
      const findIndex = postData.posts?.findIndex((x) => x?.id == item?.id);
      postData.posts[findIndex] = updatedPostItem;
      const userconv = [
        postData,
        ...userconvo?.filter((x) => x?.id !== item?.pk),
      ];
      dispatch(setConvo(userconv));
      setConvoPost(postData.posts);
      setTranslateItem(updatedPostItem);

      return;
    }

    // Translation doesn't exist, make API call
    const fk: AV.IFK = {
      id: item?.id,
      pk: item.pk,
      region: item?.region,
      type: "Convo",
    };

    try {
      const postItem = await Post.translate(fk);
      if (!postItem) return;

      const updatedPostItem: any = {
        ...postItem,
        isTranslateText: true,
        children: (item as any).children ?? (postItem as any).children,
        ReplyPost: (item as any).ReplyPost ?? (postItem as any).ReplyPost,
        galleryPost: (item as any).galleryPost ?? (postItem as any).galleryPost,
      };

      const postData = userconvo?.find((x) => x?.id === postItem?.pk);
      const findIndex = postData.posts?.findIndex((x) => x?.id == postItem?.id);
      postData.posts[findIndex] = updatedPostItem;
      const userconv = [
        postData,
        ...userconvo?.filter((x) => x?.id !== postItem?.pk),
      ];
      dispatch(setConvo(userconv));
      setConvoPost(postData.posts);
      setTranslateItem(updatedPostItem);
    } catch (error) {
      console.error("Translation Error:", error);
    }
  };

  // Shows original text after translation
  const handleShowOriginalText = (item) => {
    const updatedPostItem = { ...item, isTranslateText: false };

    const postData = userconvo?.find((x) => x?.id === item?.pk);
    const findIndex = postData.posts?.findIndex((x) => x?.id == item?.id);
    postData.posts[findIndex] = updatedPostItem;
    const userconv = [
      postData,
      ...userconvo?.filter((x) => x?.id !== item?.pk),
    ];
    dispatch(setConvo(userconv));
    setConvoPost(postData.posts);
    setItemEdit(updatedPostItem);
  };

  // Handles editing message sets
  const HandleEditSet = (item) => {
    setItemEdit("");
    setEditingImage(false);
    setShowConvoFilePicker(false);
    setUpdateConvoImage([]);
    setUpdateConvoVideo([]);

    if (item?.ptype !== "H") {
      setEditingImage(true);
      setIsSetText(true);
      setValue(item?.text);
      setItemEdit(item);
      setShrink(item?.text?.trim()?.length > 0 ? true : false);

      let img: any = [];
      let videoUrl: any = [];

      if (
        (item?.media?.type?.startsWith("image") && !item?.media?.linkURL) ||
        item?.media?.linkURL
      )
        img.push(item.media);
      else if (item?.media?.type?.startsWith("video") && !item?.media?.linkURL)
        videoUrl.push(item.media);

      item?.galleryPost?.map((item1: any) => {
        if (
          (item1?.media?.type?.startsWith("image") && !item1?.media?.linkURL) ||
          item?.media?.linkURL
        )
          img.push(item1.media);
        else if (
          item1?.media?.type?.startsWith("video") &&
          !item1?.media?.linkURL
        )
          videoUrl.push(item1.media);
      });

      setUpdateConvoImage(img);
      setUpdateConvoVideo(videoUrl);

      if (
        item?.media?.type?.trim()?.length > 0 ||
        item?.galleryPost?.length > 0
      ) {
        setShowConvoFilePicker(true);
      }
      if (item?.media?.type == "iframe") {
        setShowConvoFilePicker(true);
        setValue(media?.linkURL);
        //setImages(item?.media?.orgFile)
      }
      setTimeout(resetTextState, 2000);
    } else {
      setValue("");
      setItemEdit(item);
      setRteValue(item?.text ?? "");
      setUseRichText(true);
    }
  };

  // Resets text state
  const resetTextState = () => {
    setIsSetText(false);
  };

  // Updates post content
  const handleUpdatePost = async (itemEdit: any) => {
    if (value && profanity.exists(value)) {
      let clientError = { message: Loc.currentLang.menu.inappropriateErrorMsg };
      CustomToast({ clientError });
      return;
    }

    setConvoLoading(true);

    let media: any = [];
    updateConvoImage?.forEach((ele) => {
      media.push(ele);
    });
    updateConvoVideo?.forEach((ele) => {
      media.push(ele);
    });

    let gallery = { layout: null, Items: [] };
    let galleryArray: any = [];
    itemEdit.gallery = gallery;
    const originalText = useRichText ? itemEdit.text : itemEdit.text;

    let textContent = useRichText ? rteValue.trim() : value;
    if (useRichText) {
      // Replace base64 images with uploaded links
      textContent = await replaceBase64WithLinks(
        textContent,
        currentUser?.region,
      );

      // Remove previous wrapper div with background styles
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = textContent;

      // If the top element is a div with inline style, unwrap it
      const firstChild = tempDiv.firstElementChild as HTMLElement | null;
      if (
        firstChild &&
        firstChild.tagName === "DIV" &&
        (firstChild.style.backgroundColor || firstChild.style.backgroundImage)
      ) {
        textContent = firstChild.innerHTML; // unwrap inner content
      }

      // Wrap content with the current background color/image
      if (bgColor || bgImage) {
        textContent = `<div style="
          ${bgColor ? `background-color: ${bgColor};` : ""}
          ${
            bgImage
              ? `
            background-image: url(${bgImage});
            background-size: contain;
            background-position: left;
            background-repeat: no-repeat;
            width: ${bgImgWidth ? `${bgImgWidth}px` : "auto"};
            height: ${bgImgHeight ? `${bgImgHeight}px` : "auto"};
          `
              : ""
          }
        ">${textContent}</div>`;
      }
    }
    itemEdit.text = textContent;

    if (!itemEdit?.media || media.length === 0) itemEdit.media = null;

    //// Attach metadata (parent + linkURL)
    //for (const mediaItem of media) {
    //  const srclink = Media.getURL(mediaItem);
    //  if (!srclink) continue;
    //  mediaItem.parent = AVEntity.getFk(itemEdit.owner);
    //  mediaItem.linkURL = srclink;
    //}

    if (media && media.length === 1) {
      itemEdit.media = media[0];
    }

    let galleryPost: any = [];
    if (media && media?.length > 1) {
      itemEdit.media = null;
      for (var i = 0; i < media?.length; i++) {
        let galleryPostlist = itemEdit?.galleryPost?.filter(
          (x) => x.media.id == media[i].id,
        );
        if (galleryPostlist?.length === 0 || galleryPostlist === undefined) {
          let param1: AV.IFeedParam = {
            feed: AVBase.getFk(itemEdit.owner),
            startDate: new Date(0),
            forward: true,
          };

          if (param1?.feed?.id) {
            let post1: any = {
              pk: param1?.feed?.id,
              region: param1?.feed?.region,
            };
            post1.parentPost = itemEdit.id;
            post1.owner = AVEntity.getFk(itemEdit.owner);
            post1.media = media[i];
            post1.ptype = "G";
            let childresponse: any = await Post.saveConvo(post1);

            if (childresponse === Loc.currentLang.menu.inappropriateErrorMsg) {
              let clientError = {
                message: Loc.currentLang.menu.inappropriateErrorMsg,
              };
              CustomToast({ clientError });
              setConvoLoading(false);
              itemEdit.text = originalText;
              return;
            }
            galleryArray.push(childresponse.id);
            galleryPost.push(childresponse);
          }
        } else {
          galleryArray.push(
            itemEdit.galleryPost?.filter((x) => x.media.id == media[i]?.id)[0]
              .id,
          );
          galleryPost.push(
            itemEdit.galleryPost?.filter(
              (x) => x.media.id == media[i]?.id,
            )[0] as AV.IPost,
          );
        }
      }
    }

    // Handle deleted images
    if (deletedImages.length > 0) {
      for (const id of deletedImages) {
        try {
          // find the item in galleryPost
          const selectedItem = itemEdit?.galleryPost?.find(
            (x) => x?.media?.id === id,
          );

          if (selectedItem) {
            selectedItem.status = "Deleted";
            await Post.delete(selectedItem);
          }
        } catch (error) {
          console.error("Failed to delete image:", error);
        }
      }

      // Clear deleted images list after deletion
      setDeletedImages([]);
    }

    itemEdit.gallery.Items = galleryArray;
    itemEdit.galleryPost = [];
    let val: any = await Post.save(itemEdit);
    if (val === Loc.currentLang.menu.inappropriateErrorMsg) {
      let clientError = { message: Loc.currentLang.menu.inappropriateErrorMsg };
      CustomToast({ clientError });
      setConvoLoading(false);
      itemEdit.text = originalText;
      return;
    }

    itemEdit.galleryPost = galleryPost;
    val.galleryPost = galleryPost;
    if (itemEdit?.children?.length > 0) val.children = itemEdit.children;
    if (itemEdit?.impressions?.length > 0)
      val.impressions = itemEdit.impressions;

    let postdata = userconvo?.find((x) => x?.id === val?.pk);
    let findIndex = postdata.posts?.findIndex((x) => x?.id == val?.id);
    postdata.posts[findIndex] = val;
    postdata.lastUpdated = val?.lastUpdated;
    let userconv = [postdata, ...userconvo?.filter((x) => x?.id !== val?.pk)];
    console.log("setconvo convo 21");
    dispatch(setConvo(userconv));

    setItemEdit("");
    if (showFilePicker) setShowFilePicker(!showFilePicker);
    if (showEmoji) setShowEmoji(!showEmoji);
    setValue("");
    setMedia([]);
    setvideos([]);
    setImages([]);
    setMessage("");
    setCommentValue("");
    handleGetConvo(itemEdit);
    setEditingImage(false);
    setConvoLoading(false);
    setEditingImage(false);
    setMedia([]);
    setreplyValue("");
    setGallery([]);
    setImagesurl([]);
    setChatMessage("");
    setShowConvoFilePicker(false);
    setUpdateConvoImage([]);
    setUpdateConvoVideo([]);
    setBgColor("");
    setBgImage("");
    setBgImgWidth("");
    setBgImgHeight("");
    setRteValue("");
    setUseRichText(false);
    dispatch(setPostPopupExpanded(false));
  };

  // Updates conversation via API
  const handleconvoApiUpdate = async (post, temporaryId) => {
    dispatch(setisActive(true));
    post = await Post.saveConvo(post);
    if (post === Loc.currentLang.menu.inappropriateErrorMsg) {
      let clientError = { message: Loc.currentLang.menu.inappropriateErrorMsg };
      CustomToast({ clientError });
      setConvoLoading(false);
      return;
    }
    // Update the UI and Redux with the actual response
    if (post) {
      // Remove the processed message from pendingMessages array
      setPendingMessages((prevPendingMessages) =>
        prevPendingMessages.filter((msg) => msg.temporaryId !== temporaryId),
      );

      let postdata = userconvo.find((x) => x.id == post.pk);
      if (
        postdata?.posts?.length == 0 ||
        postdata?.posts?.length == undefined
      ) {
        postdata.posts = [];
        postdata.posts?.unshift(post);
      } else {
        postdata.posts = postdata.posts.map((p) =>
          p.temporaryId === temporaryId ? post : p,
        );
        postdata.lastUpdated = post.lastUpdated;
      }
      let userconv = userconvo.filter((x) => x.id != post.pk);
      userconv.unshift(postdata);
      handleGetConvo(postdata);
      setConvoPost(postdata.posts);
      console.log("setConvo useconvochat 13");
      dispatch(setConvo(userconv));
    }
  };

  // Updates Redux store with new post data
  const handleReduxUpdate = async (post, newPostData) => {
    if (newPostData.text && profanity.exists(newPostData.text)) {
      return Loc.currentLang.menu.inappropriateErrorMsg;
    }

    // Immediately update UI with the new message (placeholder)
    let postdata = userconvo.find((x) => x.id == post.pk);
    if (postdata?.posts?.length == 0 || postdata?.posts?.length == undefined)
      postdata.posts = [];
    postdata?.posts.unshift(newPostData);
    postdata.lastUpdated = new Date().toISOString();
    let userconv = userconvo.filter((x) => x.id != post.pk);
    userconv.unshift(postdata);
    setConvoPost(postdata.posts);
    console.log("setConvo useconvochat 11");
    dispatch(setConvo(userconv));
    dispatch(setisActive(true));
  };

  // Replace all base64 images in HTML with uploaded URLs
  async function replaceBase64WithLinks(
    html: string,
    region: string,
    item: AV.IAVEntity = {},
  ): Promise<string> {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const imgTags = tempDiv.querySelectorAll("img");

    for (const img of imgTags) {
      const src = img.getAttribute("src");
      const imgStyle = img.getAttribute("style") || "";

      // Process only valid Base64 images
      if (!src || !src.startsWith("data:image")) continue;

      // Convert Base64 to File
      const file = base64ToFile2(src, "upload-image.jpg");
      if (!file) continue;

      // Convert to FileList
      const fileList = createFileList([file]);

      // Upload file
      const data = await Media.saveFiles(Media.getFormData(fileList), region);
      if (!data || data.length === 0) continue;

      // Get uploaded link
      const srclink = Media.getURL(data[0]);
      if (!srclink) continue;

      // Set metadata before saving
      const parentEntity = item?.id ? item : itemEdit.owner;
      data[0].parent = AVBase.getFk(parentEntity);
      //data[0].linkURL = srclink;

      // Save uploaded media
      await Media.saveMedia(data);

      // Replace Base64 src with actual URL
      img.setAttribute("src", srclink);

      // Determine image width dynamically
      const tempImage = document.createElement("img");
      tempImage.src = src;

      await new Promise<void>((resolve) => {
        tempImage.onload = () => {
          // Extract width and height from style (if any)
          const widthMatch = imgStyle.match(/width:\s*(\d+)px/i);
          const heightMatch = imgStyle.match(/height:\s*(\d+)px/i);

          let styleWidth = widthMatch ? parseInt(widthMatch[1], 10) : undefined;
          let styleHeight = heightMatch
            ? parseInt(heightMatch[1], 10)
            : undefined;

          // Fallback to actual image size if no style width/height
          const width = styleWidth ?? tempImage.width;
          const height = styleHeight ?? tempImage.height;

          //// Apply max width constraint
          //const finalWidth = width > 800 ? 800 : width;
          //const finalHeight = height

          //// Set final styles
          //img.setAttribute(
          //  "style",
          //  `width: ${finalWidth}px; height: ${finalHeight}px;`
          //);

          resolve();
        };

        tempImage.onerror = () => resolve();
      });
    }

    return tempDiv.innerHTML;
  }

  // Handles sending conversation messages
  const handleSendConvoMessage = async (item) => {
    if (item?.length == 0) {
      return;
    }

    setConvoLoading(true);
    // Scroll to the bottom of the FlatList
    if (refConvoList.current) {
      refConvoList.current.scrollToOffset({ animated: true, offset: 0 });
    }
    if (messagesEndRef.current && !useRichText) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 30);
    }

    let textContent = useRichText ? rteValue.trim() : value;
    if (useRichText) {
      await sleep(2000);
      // Replace base64 images with uploaded links
      textContent = await replaceBase64WithLinks(
        textContent,
        currentUser?.region,
        item,
      );

      // Remove previous wrapper div with background styles
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = textContent;

      // If the top element is a div with inline style, unwrap it
      const firstChild = tempDiv.firstElementChild as HTMLElement | null;
      if (
        firstChild &&
        firstChild.tagName === "DIV" &&
        (firstChild.style.backgroundColor || firstChild.style.backgroundImage)
      ) {
        textContent = firstChild.innerHTML; // unwrap inner content
      }

      // Wrap content with the current background color/image
      if (bgColor || bgImage) {
        textContent = `<div style="
          ${bgColor ? `background-color: ${bgColor};` : ""}
          ${
            bgImage
              ? `
            background-image: url(${bgImage});
            background-size: contain;
            background-position: left;
            background-repeat: no-repeat;
            width: ${bgImgWidth ? `${bgImgWidth}px` : "auto"};
            height: ${bgImgHeight ? `${bgImgHeight}px` : "auto"};
          `
              : ""
          }
        ">${textContent}</div>`;
      }
    }

    let post: any = Convo.createConvoPost(item);
    post.owner = AVEntity.getFk(item);
    post.text = textContent;
    post.ptype = useRichText ? "H" : null;

    if (replyValue?.id) post.parentPost = replyValue.id;
    post.person = AVEntity.getFk(currentUser);
    var clientPost = post;

    //// Attach metadata (parent + linkURL)
    //for (const mediaItem of media) {
    //  const srclink = Media.getURL(mediaItem);
    //  if (!srclink) continue;
    //  mediaItem.parent = AVEntity.getFk(item);
    //  mediaItem.linkURL = srclink;
    //}

    if (media && media.length === 0 && !replyValue?.id) {
      const temporaryId = new Date().getTime() + Math.random();
      const newPostData = {
        ...post,
        status: "pending",
        temporaryId: temporaryId, // Temporary ID to track the post
      };
      setPendingMessages((prevPendingMessages) => [
        ...prevPendingMessages,
        newPostData,
      ]);
      handleconvoApiUpdate(post, temporaryId);
      handleReduxUpdate(post, newPostData);
      dispatch(setisActive(true));
    }
    if (media && media.length === 0 && replyValue?.id) {
      //post = await Post.saveConvo(post);
      //if (post) {
      //    let postdata = userconvo.filter((x) => x.id == post.pk)[ 0 ];
      //    postdata.posts.push(post);
      //    postdata.lastUpdated = post.lastUpdated;
      //    let userconv = userconvo.filter((x) => x.id != post.pk);
      //    userconv.unshift(postdata);
      //    setConvoPost(postdata.posts)
      //    dispatch(setConvo(userconv));
      //}
      //dispatch(setisActive(true));
      const temporaryId = new Date().getTime() + Math.random();
      const newPostData = {
        ...post,
        status: "pending",
        temporaryId: temporaryId, // Temporary ID to track the post
      };
      setPendingMessages((prevPendingMessages) => [
        ...prevPendingMessages,
        newPostData,
      ]);
      handleconvoApiUpdate(post, temporaryId);
      handleReduxUpdate(post, newPostData);
      dispatch(setisActive(true));
    }

    if (media && media.length == 1) {
      post.media = media[0];
      //if ( media[ 0 ]?.linkURL )
      //{
      //    post.text = media[ 0 ]?.orgFile?.startsWith( "GoogleDrive" ) ? value !== null ? value : "" + " " + media[ 0 ]?.linkURL : value !== null ? value : "" + " " + media[ 0 ]?.orgFile;
      //}
      const temporaryId = new Date().getTime() + Math.random();
      const newPostData = {
        ...post,
        status: "pending",
        temporaryId: temporaryId, // Temporary ID to track the post
      };
      setPendingMessages((prevPendingMessages) => [
        ...prevPendingMessages,
        newPostData,
      ]);
      handleconvoApiUpdate(post, temporaryId);
      handleReduxUpdate(post, newPostData);
      dispatch(setisActive(true));
    }
    if (media && media.length > 1) {
      let galleryArray: any = [];
      let galleryPost: any = [];
      let gallery = { layout: null, Items: [] };
      post.gallery = gallery;
      const newGuid = Server.generateUUID();
      post.id = newGuid;
      let parentPostId = newGuid;

      const mediaPromises = media.map((mediaItem) => {
        let post1 = Convo.createConvoPost(item);
        post1.owner = AVEntity.getFk(item);
        post1.parentPost = parentPostId;
        post1.media = mediaItem;
        post1.ptype = "G";
        return Post.saveConvo(post1).then((mediapost: any) => {
          if (mediapost === Loc.currentLang.menu.inappropriateErrorMsg) {
            let clientError = {
              message: Loc.currentLang.menu.inappropriateErrorMsg,
            };
            CustomToast({ clientError });
            setConvoLoading(false);
            return;
          }

          dispatch(setisActive(true));
          galleryPost.push(mediapost);
          galleryArray.push(mediapost.id);
        });
      });

      await Promise.all(mediaPromises);
      post.status = "New";
      post.gallery.items = galleryArray;
      const savedPost = await Post.saveConvo(post); // Handle the final post save with a promise
      if (savedPost === Loc.currentLang.menu.inappropriateErrorMsg) {
        let clientError = {
          message: Loc.currentLang.menu.inappropriateErrorMsg,
        };
        CustomToast({ clientError });
        setConvoLoading(false);
        return;
      }

      dispatch(setisActive(true));
      post = savedPost;
      post.galleryPost = galleryPost;
      if (post?.id) {
        let postdata = userconvo?.find((x) => x?.id === post?.pk);
        if (postdata?.id) {
          postdata.posts = [post, ...postdata.posts];
          postdata.lastUpdated = post?.lastUpdated;
          let userconvCopy = [...userconvo];
          const index = userconvCopy?.findIndex((x) => x?.id === post?.pk);
          if (index !== -1) {
            userconvCopy[index] = {
              ...userconvCopy[index],
              posts: postdata.posts,
              lastUpdated: post?.lastUpdated,
            };
            dispatch(setConvo(userconvCopy));
          }
        }
      }
    }
    setreplyValue("");
    setGallery([]);
    setMedia([]);
    setImages([]);
    setImagesurl([]);
    setChatMessage("");
    setValue("");
    setMedia([]);
    handleGetConvo(item);
    setShowConvoFilePicker(false);
    setConvoLoading(false);
    setUpdateConvoImage([]);
    setUpdateConvoVideo([]);
    setBgColor("");
    setBgImage("");
    setBgImgWidth("");
    setBgImgHeight("");
    setRteValue("");
    setUseRichText(false);
    dispatch(setPostPopupExpanded(false));
    setShrink(false); // Reset shrink state
    setIsSetText(false); // Reset text state

    if (messagesEndRef.current && useRichText) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 30);
    }
  };

  // Handles chat message input
  const handleChatMessage = (e) => {
    SignalRService.sendTyping(
      convo?.id,
      convo?.type === "GameGroupConvo" || convo?.type === "LeagueGameGroupConvo"
        ? convo?.type
        : null,
    );

    console.log(e.target.value);
    setValue(e.target.value);
    setChatMessage(e.target.value);
    setShrink(e.target.value?.trim()?.length > 0 ? true : false);
  };

  // get the gallery image
  const getImageGalleryFromFilePickerConvoChat = async (filePickerData) => {
    if (filePickerData.length > 0) {
      if (filePickerData.length > 20) {
        return;
      }
      const data = await Media.saveFiles(
        Media.getFormData(filePickerData),
        currentUser?.region,
      );
      if (data != null) setMedia((prev) => [...prev, ...data]);
      data?.forEach((img: any) => {
        if (img.type.startsWith("image"))
          setImages((images) => [...images, img]);
        else setvideos((videos) => [...videos, img]);
      });
    }
  };

  // File Picker
  const handleFilePicker = () => {
    setShowConvoFilePicker(!showConvoFilePicker);
    setEditingImage(!editingImage);
    setItemEdit("");
    setMedia([]);
    setImages([]);
    setImagesurl([]);
  };

  // Refresh the conversation if privateIds are more than current posts
  // Utility: group ids by feed
  const groupByFeed = (items: { feed: AV.IFK; id: string }[]) => {
    const map = new Map<string, { feed: AV.IFK; ids: string[] }>();
    items.forEach(({ feed, id }) => {
      if (!feed?.id) return;
      if (!map.has(feed.id)) map.set(feed.id, { feed, ids: [] });
      map.get(feed.id)!.ids.push(id);
    });
    return Array.from(map.values());
  };

  // Utility: get earliest post date
  const getMinDate = (posts: AV.IPost[]): Date | undefined => {
    // Filter out posts that don't have a valid createDate
    const validPosts = posts.filter(
      (p) => p.createDate && !isNaN(new Date(p.createDate).getTime()),
    );

    if (!validPosts.length) return undefined;

    // Reduce to find the earliest post by createDate
    const minPost = validPosts.reduce((min, curr) =>
      new Date(curr.createDate!) < new Date(min.createDate!) ? curr : min,
    );

    return new Date(minPost.createDate!);
  };

  // Main refresh
  const onRefresh = async () => {
    // Capture the chat ID at the start of this refresh
    const refreshConvoId = currentConvoIdRef.current;
    let currentConvo = convo;

    // Filter out already loaded posts and gallery posts
    const postIds = new Set(currentConvo?.posts?.map((p) => p.id));
    const galleryPostIds =
      currentConvo.posts?.flatMap((p) =>
        Array.isArray(p.galleryPost)
          ? p.galleryPost.filter((g) => g?.id).map((g) => g.id)
          : [],
      ) || [];
    const galleryPostIdSet = new Set(galleryPostIds);

    let filteredPrivateIds =
      currentConvo?.privateIds?.filter(
        (x) => !postIds.has(x.id) && !galleryPostIdSet.has(x.id),
      ) || [];

    currentConvo.privateIds = filteredPrivateIds;

    // Nothing to fetch and no more posts
    if (!filteredPrivateIds.length && !currentConvo.hasMore) return false;

    const convoFeed: AV.IFK = {
      id: convo?.id,
      pk: convo?.pk,
      region: convo?.region,
      type: convo?.type,
    };

    // If no privateIds but hasMore -> fetch old posts
    if (!filteredPrivateIds.length && currentConvo.hasMore) {
      const feedsResponse = (await Feed.getAllFeeds([
        {
          feed: convoFeed,
          checkArchive: false,
          forward: false,
          startDate: getMinDate(currentConvo.posts) ?? null,
        },
      ])) as AV.IConversation[];

      // Check if user switched chats before API returned
      if (!feedsResponse?.[0] || refreshConvoId !== currentConvoIdRef.current)
        return;

      // Update current convo and local state
      currentConvo = feedsResponse[0];
      currentConvo.posts = convo.posts;
      currentConvo.privateIds = feedsResponse[0].privateIds;
      filteredPrivateIds = feedsResponse[0].privateIds;
      setConvos(currentConvo);
    }

    // Fetch unseen privateIds
    if (filteredPrivateIds?.length > 0) {
      setFetchLoading(true);

      // Take first 20 ids
      const flattened = filteredPrivateIds
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        .slice(0, 20)
        .map((x) => ({ feed: convoFeed, id: x.id }));

      const firstBatch = groupByFeed(flattened);

      let fetchPosts =
        firstBatch.length > 0 ? await Feed.getAllPosts(firstBatch) : [];

      if (refreshConvoId !== currentConvoIdRef.current) {
        setFetchLoading(false);
        return;
      }

      // If all are parent posts → fetch old posts again
      if (fetchPosts?.every((x) => x.parentPost)) {
        const feedsResponse = (await Feed.getAllFeeds([
          {
            feed: convoFeed,
            checkArchive: false,
            forward: false,
            startDate: getMinDate(currentConvo.posts) ?? null,
          },
        ])) as AV.IConversation[];

        if (!feedsResponse?.[0] || refreshConvoId !== currentConvoIdRef.current)
          return;

        currentConvo = feedsResponse[0];
        currentConvo.posts = convo.posts;
        currentConvo.privateIds = feedsResponse[0].privateIds;
        filteredPrivateIds = feedsResponse[0].privateIds;

        const flattened = filteredPrivateIds
          .sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
          )
          .slice(0, 20)
          .map((x) => ({ feed: convoFeed, id: x.id }));

        fetchPosts =
          flattened.length > 0
            ? await Feed.getAllPosts(groupByFeed(flattened))
            : [];

        if (refreshConvoId !== currentConvoIdRef.current) {
          setFetchLoading(false);
          return;
        }
      }

      // Fetch replies
      if (Array.isArray(fetchPosts)) {
        fetchPosts = await fetchReplyPosts(fetchPosts, firstBatch);
      }

      // Merge posts into convo
      const convoChat = userconvo?.find((x) => x?.id === currentConvo.id);
      if (!convoChat) return;

      let allFeeds = _.uniqBy(
        [...(convoChat.posts ?? []), ...fetchPosts],
        "id",
      );

      allFeeds = list_to_tree(allFeeds).sort(
        (a, b) =>
          new Date(b.createDate).getTime() - new Date(a.createDate).getTime(),
      );

      // Check again before updating state
      if (refreshConvoId !== currentConvoIdRef.current) {
        setFetchLoading(false);
        return;
      }

      // Update the post list in local and redux state
      convoChat.posts = allFeeds;
      currentConvo.posts = allFeeds;
      convoChat.privateIds = currentConvo.privateIds;
      setConvos(convoChat);

      const index = userconvo.findIndex((x) => x.id === convoChat.id);
      if (index !== -1) userconvo[index] = convoChat;

      dispatch(setConvo([...userconvo])); // Trigger redux update
      handleGetConvo(currentConvo); // Refresh UI
      setFetchLoading(false);
    }
  };

  // Fetch reply posts
  async function fetchReplyPosts(
    postList: AV.IPost[],
    postsToFetch: AV.IPostListParam[],
  ): Promise<AV.IPost[]> {
    const replyPostIds = postList
      .filter((x) => Array.isArray(x.posts) && x.posts.length > 0) // Only posts with nested replies
      .map((x) => ({ id: x.id, pk: x.pk, posts: x.posts })); // Collect their post IDs and pk

    if (replyPostIds.length === 0) return postList; // No replies to fetch

    const replyPostListParams: AV.IPostListParam[] = [];
    const uniquePks = [
      ...new Set(
        replyPostIds.map((r) => r.pk).filter((pk): pk is string => !!pk),
      ),
    ]; // Unique pk list

    // Match original fetch request with replies using pk
    uniquePks.forEach((pk) => {
      const matchedFeed = postsToFetch.filter((x) => x.feed.pk === pk);
      if (matchedFeed.length > 0) {
        replyPostListParams.push({
          feed: matchedFeed[0].feed,
          ids: replyPostIds.find((x) => x.pk === pk)?.posts || [],
        });
      }
    });

    const replyPostList = await Feed.getAllPosts(replyPostListParams); // Fetch reply posts
    return _.uniqBy([...postList, ...replyPostList], "id"); // Merge with original and dedupe
  }

  // Function to set up the SignalR connection
  const setupSignalRConnection = async (convoId) => {
    SignalRService.onClearTyping(() => {
      setTypingUserName("");
    });
    // Register the typing event handler
    SignalRService.onTyping((receivedConvoId, userName) => {
      console.log("Typing event received:", { receivedConvoId, userName });

      // Update typing indicator if the event is for the current conversation and from a different user
      if (receivedConvoId === convoId && currentUser.name !== userName) {
        setTypingUserName(`${userName} ${Loc.currentLang.convo.isTyping}`);
        console.log(
          `${userName} is typing in conversation ${receivedConvoId}...`,
        );
      }
    });

    SignalRService.onPreStart((connection: signalR.HubConnection) => {
      connection.on("Impression", async (data, alertType) => {
        console.log("Impression event received:", data, alertType);
        SignalRService.clearTyping();
        await handleImpressionAlerts(data, alertType);
      });

      connection.on("NewDM", async (data, alertType) => {
        console.log("NewDM event received", data, alertType);
        SignalRService.clearTyping();
        await handleQuickChat(data, alertType);
      });
      connection.on("ReplyDM", async (data, alertType) => {
        console.log("ReplyDM event received", data, alertType);
        SignalRService.clearTyping();
        await handleNewDMAlertforSing(data, alertType);
      });
      connection.on("DeleteDM", async (data, alertType) => {
        console.log("Delete DM event received", data, alertType);
        SignalRService.clearTyping();
        await handleDeleteDMAlertforSigR(data, alertType);
      });
    });

    // Add a group with the convoId and add the current user to the group
    await SignalRService.joinGroup(
      convoId,
      convo?.type === "GameGroupConvo" || convo?.type === "LeagueGameGroupConvo"
        ? convo?.type
        : null,
    );
  };

  // Reply for SignalR in Convo chat
  async function handleNewDMAlertforSing(target, item) {
    const reduxState = store.getState();
    const { user, convo } = reduxState;
    const userconvos: any = userconvo;
    const lastUpdateFeeds = lastUpdateFeed;
    const feedId = item?.feed?.id;
    const postdata = userconvo?.find((x) => x?.id === feedId);
    const post = postdata?.posts?.find((x) => x?.id === target?.id);

    let PostList: any = [];
    PostList[0] = item?.data?.postObj?.id;
    if (item?.data?.postObj?.gallery?.items?.length > 0) {
      PostList[0] = [PostList[0], ...item?.data?.postObj?.gallery?.items];
    }
    let response: any = userconvo?.find((x) => x?.id === item?.feed?.id);
    if (response) {
      await Feed.getPosts(
        AVEntity.getFk(response),
        PostList?.slice(0, 50),
      ).then((x) => {
        if (x?.length > 0) {
          var usercon = userconvo || [];
          let Index = response.posts?.findIndex((y) => y.id == x[0]?.id);
          if (Index !== -1) {
            // response.posts[ Index ] = x[0];
            response.posts = response.posts?.filter((y) => y.id !== x[0]?.id);
            response.posts = list_to_tree(response?.posts);
            response?.posts?.sort((a, b) => {
              return (
                (new Date(b.createDate) as any) -
                (new Date(a.createDate) as any)
              );
            });
            usercon = userconvo?.filter((x) => x?.id != item?.data?.feed?.id);
            usercon.unshift(response);
            usercon = _.uniqBy(usercon, "id");
            dispatch(setConvo(usercon));

            //unshift the edited one
            response.posts?.unshift(post?.id ? post : x[0]);
            response.posts = list_to_tree(response?.posts);
            response?.posts?.sort((a, b) => {
              return (
                (new Date(b.createDate) as any) -
                (new Date(a.createDate) as any)
              );
            });
            usercon = userconvo?.filter((x) => x?.id != item?.feed?.id);
            usercon.unshift(response);
            usercon = _.uniqBy(usercon, "id");
          } else {
            response.posts?.unshift(post?.id ? post : x[0]);
            response.posts = _.uniqBy(response?.posts, "id");
            //response.lastUpdated = x[ 0 ].lastUpdated;
            response.posts = list_to_tree(response?.posts);
            response?.posts?.sort((a, b) => {
              return (
                (new Date(b.createDate) as any) -
                (new Date(a.createDate) as any)
              );
            });
            usercon = userconvo?.filter((x) => x?.id != item?.feed?.id);
            usercon.unshift(response);
            usercon = _.uniqBy(usercon, "id");
          }
        }

        if (usercon === undefined) {
          let newPosts = [...(response?.posts || [])];

          if (target) {
            newPosts.push(target);
          }

          newPosts = _.uniqBy(newPosts, "id");
          response.posts = list_to_tree(newPosts);

          response?.posts?.sort((a, b) => {
            return (
              (new Date(b.createDate) as any) - (new Date(a.createDate) as any)
            );
          });
          usercon = userconvo?.filter((x) => x?.id != item?.feed?.id);
          usercon.unshift(response);
          usercon = _.uniqBy(usercon, "id");
        }

        dispatch(setConvo(usercon));
      });
    } else {
      const feedParam: AV.IFeedParam = {
        feed: item?.feed,
        startDate:
          postdata?.posts?.length > 0 ? postdata?.lastUpdated : new Date(0),
        forward: true,
      };
      await Feed.getFeed(feedParam).then(async (response: any) => {
        if (response?.id) {
          let PostList = await Feed.getPostList(response);
          PostList = PostList?.filter((item) => item !== null);
          if (PostList.length > 0) {
            await Feed.getPosts(AVEntity.getFk(response), PostList).then(
              (x) => {
                if (x?.length > 0) {
                  response.posts = x;
                  response.posts = list_to_tree(response?.posts);
                  var usercon = userconvo || [];
                  const existingconvo = usercon.find(
                    (x) => x?.id === response?.id,
                  );
                  if (!existingconvo) {
                    usercon.unshift(response);
                  }
                  dispatch(setConvo(usercon));
                }
              },
            );
          }
        }
      });
    }

    //Temporary code to update feeds in background
    if (!response?.id) {
      const feedParam: AV.IFeedParam = {
        feed: item?.feed,
        startDate:
          postdata?.posts?.length > 0 ? postdata?.lastUpdated : new Date(0),
        forward: true,
      };
      await Feed.getFeed(feedParam).then(async (response: any) => {
        if (response?.id) {
          //set last successful get feed
          let data = {
            Ifeed: feedParam,
            lasttime: new Date(),
          };
          let Index = lastUpdateFeed?.findIndex(
            (x) => x?.Ifeed?.feed?.id == item?.feed?.id,
          );
          if (Index !== -1) {
            lastUpdateFeed[Index] = data;
          }
          dispatch(setLastFeedUpdate(lastUpdateFeed));
          let PostList = await Feed.getPostList(response);
          PostList = PostList?.filter((item) => item !== null);
          if (PostList.length > 0) {
            await Feed.getPosts(AVEntity.getFk(response), PostList).then(
              (x) => {
                if (x?.length > 0) {
                  response.posts = x;
                  var usercon = userconvo || [];
                  const existingconvo = usercon.find(
                    (x) => x?.id === response?.id,
                  );
                  if (!existingconvo) {
                    let user = Person._self;
                    if (!existingconvo) {
                      usercon.unshift(response);
                    } else return;
                  } else {
                    let updatedFeeds = [...(existingconvo?.posts || [])];
                    response?.posts.forEach((newconvo) => {
                      let existingFeed = existingconvo?.posts?.find(
                        (x) => x?.id === newconvo?.id,
                      );
                      if (!existingFeed) {
                        updatedFeeds.unshift(newconvo);
                      } else {
                        existingFeed.impressions = newconvo.impressions;
                        existingFeed.text = newconvo.text;
                      }
                    });
                    existingconvo.posts = _.uniqBy([...updatedFeeds], "id");
                    //existingconvo.lastUpdated = response.lastUpdated;
                    existingconvo.people = response.people;
                    usercon.unshift(existingconvo);
                    usercon = _.uniqBy(usercon, "id");
                  }
                  dispatch(setConvo(usercon));
                }
              },
            );
          }
        }
        if (
          mdlCreateConvoVisible &&
          mdlConvoVisible &&
          currentconvochat?.id === item?.feed?.id
        ) {
          handleGetConvo(item?.feed);
        }
      });
    }
    if (
      mdlCreateConvoVisible &&
      mdlConvoVisible &&
      currentconvochat?.id === item?.feed?.id
    ) {
      handleGetConvo(item?.feed);
    }

    if (messagesEndRef.current) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 30);
    }
  }

  // Signal R update for Convo chat post
  async function handleQuickChat(target, item) {
    const reduxState: any = store.getState();
    const { user, convo } = reduxState;
    const userconvo: any = convo.convo[0];
    const lastUpdateFeed = user.lastUpdateFeed;
    const feedId = item?.feed?.id;
    const postdata = userconvo?.find((x) => x?.id === feedId);
    const post = postdata?.posts?.find((x) => x?.id === target?.id);

    let PostList: any = [];
    PostList[0] = target?.id;
    var usercon = userconvo || [];
    let response = userconvo?.find((x) => x?.id === item?.feed?.id);
    if (target?.gallery?.items?.length > 0) {
      for (var i = 0; i < target?.gallery?.items?.length; i++) {
        await Post.get({
          id: target?.gallery?.items[i],
          pk: target?.pk,
          region: target?.region,
          type: target?.type,
        }).then((parentPost) => {
          if (!target?.galleryPost || target?.galleryPost?.length === 0)
            target.galleryPost = [];
          target.galleryPost.push(parentPost);
        });
      }
    }
    if (response) {
      const isUpdatedPost =
        response.posts?.filter((x) => x.id === target.id).length > 0;
      response.posts = response.posts?.filter((x) => x?.id !== target?.id);
      if (
        target?.text?.trim()?.length > 0 ||
        target?.media?.id.trim().length > 0 ||
        target?.gallery?.items?.length > 0 ||
        target?.galleryArray?.length > 0
      ) {
        response.posts?.unshift(target);
      }
      response.posts = list_to_tree(response?.posts);
      response?.posts?.sort((a, b) => {
        return (
          (new Date(b.createDate) as any) - (new Date(a.createDate) as any)
        );
      });
      usercon = userconvo?.filter(
        (x: IConversation) => x?.id != item?.feed?.id,
      );
      usercon.unshift(response);
      usercon = _.uniqBy(usercon, "id");
      dispatch(setConvo(usercon));
      handleGetConvo(response);

      if (messagesEndRef.current) {
        setTimeout(() => {
          messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 30);
      }
    }
  }

  async function handleDeleteDMAlertforSigR(target, alert) {
    var currentChat = userconvo?.find((x) => x?.id === alert.feed?.id);
    if (currentChat) {
      currentChat.posts = currentChat?.posts?.filter(
        (x) => x?.id !== target?.id,
      );
      userconvo[userconvo.indexOf(currentChat)] = currentChat;
      dispatch(setConvo(userconvo));
      handleGetConvo(currentChat);
    }
  }

  //Firebase Update for update the convo chat post
  async function handleNewDMAlert(item) {
    const reduxState = store.getState();
    const { user, convo } = reduxState;
    const userconvos = userconvo;
    const lastUpdateFeeds = lastUpdateFeed;
    const feedId = item?.data?.feed?.id;
    const postdata = userconvo?.find((x) => x?.id === feedId);

    const post = postdata?.posts?.find((x) => x?.id === item?.target?.id);
    if (
      post?.text != undefined &&
      item?.data?.postObj?.text != undefined &&
      post?.text == item?.data?.postObj?.text
    ) {
      return;
    }

    let postId = item?.data?.postObj?.id;
    let galleryItems = item?.data?.postObj?.gallery?.items ?? [];
    let postIds =
      galleryItems.length > 0 ? [postId, ...galleryItems] : [postId];
    let response = userconvo?.find((x) => x?.id === item?.data?.feed?.id);

    if (response && !item?.data?.postObj?.id) {
      await Feed.getAllPosts([
        {
          feed: AVEntity.getFk(response),
          ids: postIds.slice(0, 50),
        },
      ]).then((x: any) => {
        if (x?.length > 0) {
          var usercon = userconvo || [];
          response = userconvo?.find(
            (x: any) => x?.id === item?.data?.feed?.id,
          );
          x = list_to_tree(x);
          let Index = response.posts?.findIndex((y) => y.id == x[0]?.id);
          if (Index !== -1 && Index !== undefined) {
            let Posts = response.posts[Index];
            // response.posts[ Index ] = x[0];
            response.posts = response.posts?.filter((y) => y.id !== x[0]?.id);
            response.posts = list_to_tree(response?.posts);
            response?.posts?.sort((a, b) => {
              return (
                (new Date(b.createDate) as any) -
                (new Date(a.createDate) as any)
              );
            });
            usercon = userconvo?.filter((x: any) => x?.id != item?.feed?.id);
            usercon.unshift(response);
            usercon = _.uniqBy(usercon, "id");
            dispatch(setConvo(usercon));

            //unshift the edited one
            if (
              Posts?.text?.trim()?.length > 0 ||
              Posts?.media?.id.trim().length > 0 ||
              Posts?.gallery?.items?.length > 0 ||
              Posts?.galleryArray?.length > 0
            ) {
              response.posts?.unshift(Posts);
            }
            response.posts = list_to_tree(response?.posts);
            response?.posts?.sort((a, b) => {
              return (
                (new Date(b.createDate) as any) -
                (new Date(a.createDate) as any)
              );
            });
            usercon = userconvo?.filter(
              (x: any) => x?.id != item?.data?.feed?.id,
            );
            usercon.unshift(response);
            usercon = _.uniqBy(usercon, "id");
          } else {
            if (
              x[0]?.text?.trim()?.length > 0 ||
              x[0]?.media?.id.trim().length > 0 ||
              x[0]?.gallery?.items?.length > 0 ||
              x[0]?.galleryArray?.length > 0
            ) {
              response.posts?.unshift(x[0]);
            }
            response.posts = _.uniqBy(response?.posts, "id");
            //response.lastUpdated = x[ 0 ].lastUpdated;
            response.posts = list_to_tree(response?.posts);
            response?.posts?.sort((a, b) => {
              return (
                (new Date(b.createDate) as any) -
                (new Date(a.createDate) as any)
              );
            });
            usercon = userconvo?.filter(
              (x: any) => x?.id != item?.data?.feed?.id,
            );
            usercon.unshift(response);
            usercon = _.uniqBy(usercon, "id");
          }
        }
        dispatch(setConvo(usercon));
      });
    } else if (!item?.data?.postObj?.id) {
      const feedParam: AV.IFeedParam = {
        feed: item?.data?.feed,
        startDate:
          postdata?.posts?.length > 0 ? postdata?.lastUpdated : new Date(0),
        forward: true,
      };
      await Feed.getFeed(feedParam).then(async (response: any) => {
        if (response?.id) {
          let PostList = await Feed.getPostList(response);
          PostList = PostList?.filter((item) => item !== null);
          if (PostList.length > 0) {
            await Feed.getPosts(AVEntity.getFk(response), PostList).then(
              (x: any) => {
                if (x?.length > 0) {
                  response.posts = x;
                  response.posts = list_to_tree(response?.posts);
                  var usercon = userconvo || [];
                  const existingconvo = usercon.find(
                    (x: any) => x?.id === response?.id,
                  );
                  if (!existingconvo) {
                    usercon.unshift(response);
                  }
                  dispatch(setConvo(usercon));
                }
              },
            );
          }
        }
      });
    } else {
      let usercon = userconvo || [];
      response.posts?.unshift(item?.data?.postObj);
      response.posts = _.uniqBy(response?.posts, "id");
      //response.lastUpdated = x[0].lastUpdated;
      response.posts = list_to_tree(response?.posts);
      response?.posts?.sort((a, b) => {
        return (
          (new Date(b.createDate) as any) - (new Date(a.createDate) as any)
        );
      });
      usercon = userconvo?.filter((x: any) => x?.id != item?.data?.feed?.id);
      usercon.unshift(response);
      usercon = _.uniqBy(usercon, "id");
      dispatch(setConvo(usercon));
    }

    if (!response) {
      //Temporary code to update feeds in background
      const feedParam: AV.IFeedParam = {
        feed: item?.data?.feed,
        startDate:
          postdata?.posts?.length > 0 ? postdata?.lastUpdated : new Date(0),
        forward: true,
      };
      await Feed.getFeed(feedParam).then(async (response: any) => {
        if (response?.id) {
          //set last successful get feed
          let data: any = {
            Ifeed: feedParam,
            lasttime: new Date(),
          };
          let Index = lastUpdateFeed?.findIndex(
            (x) => x?.Ifeed?.feed?.id == item?.feed?.id,
          );
          if (Index !== -1) {
            lastUpdateFeed[Index] = data;
          }
          dispatch(setLastFeedUpdate(lastUpdateFeed));

          let PostList = await Feed.getPostList(response);
          PostList = PostList?.filter((item) => item !== null);
          if (PostList.length > 0) {
            await Feed.getPosts(AVEntity.getFk(response), PostList).then(
              (x) => {
                if (x?.length > 0) {
                  response.posts = x;
                  var usercon = userconvo || [];
                  const existingconvo = usercon.find(
                    (x) => x?.id === response?.id,
                  );
                  if (!existingconvo) {
                    let user: AV.IPerson = Person._self;
                    if (!existingconvo) {
                      usercon.unshift(response);
                    } else return;
                  } else {
                    let updatedFeeds = [...(existingconvo?.posts || [])];
                    response?.posts.forEach((newconvo) => {
                      let existingFeed = existingconvo?.posts?.find(
                        (x) => x?.id === newconvo?.id,
                      );
                      if (!existingFeed) {
                        if (
                          newconvo?.text?.trim()?.length > 0 ||
                          newconvo?.media?.id.trim().length > 0 ||
                          newconvo?.gallery?.items?.length > 0 ||
                          newconvo?.galleryArray?.length > 0
                        ) {
                          updatedFeeds.unshift(newconvo);
                        }
                      } else {
                        existingFeed.impressions = newconvo.impressions;
                        existingFeed.text = newconvo.text;
                      }
                    });
                    existingconvo.posts = _.uniqBy([...updatedFeeds], "id");
                    //existingconvo.lastUpdated = response.lastUpdated;
                    existingconvo.people = response.people;
                    usercon.unshift(existingconvo);
                    usercon = _.uniqBy(usercon, "id");
                  }
                  dispatch(setConvo(usercon));
                }
              },
            );
          }
        }
        if (
          mdlCreateConvoVisible &&
          mdlConvoVisible &&
          currentconvochat?.id === usernewalert?.data.feed?.id
        ) {
          handleGetConvo(usernewalert?.data?.feed);
        }
      });
    }
    if (
      mdlCreateConvoVisible &&
      mdlConvoVisible &&
      currentconvochat?.id === item?.data.feed?.id
    ) {
      handleGetConvo(item?.data?.feed);
    }

    if (messagesEndRef.current) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 30);
    }
  }

  //Signalr update for Impression for Convo
  const handleImpressionAlerts = async (data, alertData) => {
    const userFeeds = userconvo?.find((feed) => feed.id === data.pk);

    if (userFeeds) {
      const userFeedsImpression = userFeeds.posts?.find(
        (post) => post.id === data.id,
      );

      if (userFeedsImpression) {
        if (userFeedsImpression.impressions == undefined) {
          userFeedsImpression.impressions = [];
        }
        // const Impression = data.impressions;
        let Impression: any = {
          ...(await AVEntity.getFk(data?.impressions?.[0])),
        };
        if (Impression !== undefined && Impression?.id?.trim()?.length > 0) {
          Impression.impression = data?.impressions?.[0]?.impression;
          userFeedsImpression.impressions =
            userFeedsImpression.impressions?.filter(
              (impression) => impression.id !== Impression.id,
            );
          userFeedsImpression.impressions.unshift(Impression);
        } else {
          Impression = null;
          userFeedsImpression.impressions = Impression;
        }

        const postIndex = userFeeds.posts.indexOf(userFeedsImpression);
        userFeeds.posts[postIndex] = userFeedsImpression;

        const convoIndex = userconvo?.indexOf(userFeeds);
        userconvo[convoIndex] = userFeeds;
        console.log("setConvo useconvochat 2");
        dispatch(setConvo(userconvo));

        //if ( mdlCreateConvoVisible && mdlConvoVisible && currentconvochat?.id === userFeeds.id )
        //{
        handleGetConvo(userFeeds);
        //}
      }
    }
  };

  //Firebase Alert update for Impression for Convo
  const handleImpressionFireBase = async (
    usernewalert: AV.IAlert,
    alertData: any,
  ) => {
    const userFeeds = userconvo?.find(
      (feed: AV.IConversation) => feed.id === usernewalert?.target?.pk,
    );

    if (userFeeds) {
      const userFeedsImpression = userFeeds.posts?.find(
        (post: AV.IPost) => post.id === usernewalert?.target?.id,
      );

      if (userFeedsImpression) {
        let Impression: AV.IPostImpression = usernewalert?.data?.source;
        Impression.impression = usernewalert?.data?.type;
        if (userFeedsImpression.impressions == undefined) {
          userFeedsImpression.impressions = [];
        }
        userFeedsImpression.impressions =
          userFeedsImpression.impressions?.filter(
            (impression: AV.IPostImpression) => impression.id !== Impression.id,
          );
        userFeedsImpression.impressions.unshift(Impression);

        const postIndex = userFeeds.posts.indexOf(userFeedsImpression);
        userFeeds.posts[postIndex] = userFeedsImpression;

        const convoIndex = userconvo?.indexOf(userFeeds);
        if (convoIndex !== undefined && userconvo) {
          userconvo[convoIndex] = userFeeds;
          console.log("setConvo useconvochat 2");
          dispatch(setConvo(userconvo));
          handleGetConvo(userFeeds);
        }
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      const alertType = usernewalert?.alertType;
      if (
        alertType === "NewDM" ||
        alertType === "NewDM-Ward" ||
        alertType === "ReplyDM" ||
        alertType === "ReplyDM-Ward"
      ) {
      } else if (
        alertType === "EntityUpdate" &&
        usernewalert?.data === "SelfConvoPost"
      )
        if (userisactive) {
          dispatch(setisActive(false));
        } else {
          handleConvoUpdate();
        }
      else if (alertType === "Impression") {
        await handleImpressionFireBase(usernewalert, alertType);
      }
    }

    const handleConvoUpdate = async () => {
      const lastConvo = userconvo?.find(
        (x) => x?.id === usernewalert?.target?.id,
      );
      if (!usernewalert?.target) return;

      const feedParam: AV.IFeedParam = {
        feed: AVEntity.getFk(usernewalert.target as AV.IAVEntity),
        startDate:
          lastConvo?.posts?.length > 0
            ? lastConvo?.posts[0]?.lastUpdated
            : new Date(0),
        forward: true,
      };
      await Feed.getFeed(feedParam).then((response: any) => {
        var usercon = userconvo || [];
        const excitingconvo = usercon.find((x) => x?.id === response?.id);
        if (!excitingconvo) {
          usercon.unshift(response);
        } else {
          excitingconvo.posts = _.uniqBy(
            [...excitingconvo?.posts, ...response?.posts],
            "id",
          );
          excitingconvo.lastUpdated = response.lastUpdated;
          usercon.unshift(excitingconvo);
          usercon = _.uniqBy(usercon, "id");
        }
        dispatch(setConvo(usercon));
        if (
          mdlCreateConvoVisible &&
          mdlConvoVisible &&
          currentconvochat?.id === usernewalert?.target?.id
        ) {
          handleGetConvo(usernewalert?.target);
        }
      });
    };

    fetchData();
  }, [usernewalert]);

  useEffect(() => {
    if (useralertList?.length > 0 && isConvoScreenOpen.convoId) {
      const matchedAlerts = useralertList.filter(
        (alert: AV.IAlert) =>
          alert?.data?.feed?.id === isConvoScreenOpen.convoId &&
          alert?.actionTaken === undefined,
      );

      if (matchedAlerts.length > 0) {
        matchedAlerts.forEach((alert) => {
          updateUnreadMessages(alert);
        });
      }
    }
  }, [useralertList]);

  useEffect(() => {
    if (isOnedriveData?.blob !== undefined) {
      HandleAddOneDrive();
    }
  }, [isOnedriveData]);

  return {
    isImageProcessing,
    handleNewDMAlert,
    setMedia,
    textSearchRef,
    mdlCreateConvoVisible,
    setMdlCreateConvoVisible,
    toFK,
    searchInput,
    filteredResults,
    showSearch,
    showFilePicker,
    setShowFilePicker,
    handleCreateModel,
    searchItems,
    handleSentToProfile,
    handleSendMessage,
    handleSubject,
    handleMessage,
    handleRemoveItem,
    getImageGalleryFromFilePickerCreateConvo,
    mdlConvoVisible,
    setMdlConvoVisible,
    convoSubject,
    convoPost,
    setConvoPost,
    convo,
    profile,
    Setprofile,
    showConvoFilePicker,
    setShowConvoFilePicker,
    handleGetConvo,
    handleSendConvoMessage,
    handleChatMessage,
    getImageGalleryFromFilePickerConvoChat,
    value,
    setValue,
    onEmojiClick,
    showEmoji,
    handleImages,
    handleVoice,
    message,
    setMessage,
    setShowEmoji,
    isLoading,
    handleFilePicker,
    Loading,
    setLoading,
    images,
    videoUrls,
    setvideos,
    setImages,
    setDeletedImages,
    media,
    onRefresh,
    replyValue,
    setreplyValue,
    showFeedbackImpressions,
    setShowFeedbackImpressions,
    setSubject,
    settoFK,
    handlePublish,
    setIsHide,
    isHide,
    subject,
    refConvoList,
    setConvoLoading,
    HandleEditSet,
    handleUpdatePost,
    itemEdit,
    setItemEdit,
    editingImage,
    setEditingImage,
    scrollToMessageWithDelay,
    fetchloading,
    setSearchInput,
    setShowSearch,
    imageInputRef,
    updateUnreadMessages,
    isDelete,
    setIsdelete,
    updateConvoImage,
    setUpdateConvoImage,
    updateConvoVideo,
    setUpdateConvoVideo,
    handleGetGroupConvo,
    handleSendSingleChat,
    setConvoSubject,
    setConvos,
    typingUserName,
    isOpenBox,
    setIsOpenBox,
    setIsOpenCemera,
    handleOpenPicker,
    setExternalLink,
    HandleAddOneDrive,
    setShowExternalLinkInput,
    showExternalLinkInput,
    HandleAddDropBoxLink,
    isOpenCemera,
    HandleAddExternalUrl,
    handleExternalLink,
    externalLink,
    camera,
    isSetText,
    TriggerOpenConvo,
    setIsTriggerOpenConvo,
    isYoutube,
    setIsYouTube,
    setupSignalRConnection,
    setChatMessage,
    shrink,
    setShrink,
    translateItem,
    setTranslateItem,
    handleTranslateText,
    handleShowOriginalText,
    setIsOneDriveData,
    galleryPost,
    setGalleryPost,
    galleryArray,
    setGalleryArray,
    showInsufficientCredits,
    setShowInsufficientCredits,
    scrollRef,
    prevScrollHeightRef,
    prevScrollTopRef,
    loadingOldMessagesRef,
    messagesEndRef,
    cameraMode,
    setCameraMode,
    webcamRef,
    recording,
    setRecording,
    duration,
    setDuration,
    formatDuration,
    toggleMode,
    isCancelledRef,
    handleCameraPhotoCapture,
    handleStartRecording,
    handleStopRecording,
    onClose,
    addLinkLoad,
    setAddLinkLoad,
    editorRef,
    useRichText,
    setUseRichText,
    rteValue,
    setRteValue,
    toolbarOptions,
    isExpanded,
    setIsExpanded,
    setPostPopupExpanded,
    bgColor,
    setBgColor,
    bgImage,
    setBgImage,
    bgImgWidth,
    setBgImgWidth,
    bgImgHeight,
    setBgImgHeight,
    clickedUrl,
    setClickedUrl,
    showConfirmLinkPopup,
    setShowConfirmLinkPopup,
  };
};

export default useConvoChat;
